// before 20-5-2026

// import React, { useEffect, useState, useCallback } from 'react';
// import SevereColdIcon from '@mui/icons-material/SevereCold';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
// import CheckIcon from '@mui/icons-material/Check';
// import EditNoteIcon from '@mui/icons-material/EditNote';
// import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
// import CloseIcon from '@mui/icons-material/Close';
// import AssignmentIcon from '@mui/icons-material/Assignment';
// import InfoIcon from '@mui/icons-material/Info';
// import XLSX from '../utils/excelUtils';
// import axios from 'axios';
// import { db_url } from '../Api/BaseUrl';
// import { Modal, Form, Spinner } from 'react-bootstrap';
// import {
//   Box,
//   Typography,
//   Grid,
//   Card,
//   CardContent,
//   Avatar,
//   Button,
//   IconButton,
//   Tooltip,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Chip,
//   TextField,
//   InputAdornment,
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Badge,
//   Menu,
//   MenuItem,
//   TablePagination,
//   Select,
//   FormControl,
//   InputLabel,
//   Skeleton,
//   useMediaQuery,
//   useTheme,
//   Snackbar,
//   Drawer,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   Divider,
//   Checkbox,
//   Switch,
//   FormControlLabel,
//   Alert,
// } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import { useTheme as useMuiTheme } from '@mui/material/styles';
// import {
//   Search as SearchIcon,
//   FilterList as FilterIcon,
//   Refresh as RefreshIcon,
//   Visibility as ViewIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   CheckCircle as CheckCircleIcon,
//   Cancel as CancelIcon,
//   Phone as PhoneIcon,
//   Email as EmailIcon,
//   WhatsApp as WhatsAppIcon,
//   Person as PersonIcon,
//   Business as BusinessIcon,
//   CalendarToday as CalendarIcon,
//   ArrowUpward as ArrowUpIcon,
//   ArrowDownward as ArrowDownIcon,
//   MoreVert as MoreVertIcon,
//   Settings as SettingsIcon,
//   DragIndicator as DragIndicatorIcon,
//   Visibility as VisibilityIcon,
//   VisibilityOff as VisibilityOffIcon,
//   SystemUpdateAlt as ExportIcon,
//   SwapHoriz as SwapHorizIcon,
//   AddCircleOutline as AddIcon,
// } from '@mui/icons-material';
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// import moment from 'moment-timezone';
// import { Link, useLocation } from 'react-router-dom';
// import { styled } from '@mui/material/styles';
// import { Get_All_Leads_By_Email_User_Marketer_email_Action2 } from '../Redux/Actions/UsersAction';
// import { Notify } from '../Utility/Notify';
// import { ClientTable2 } from '../Component/ClientTable2';
// import { ShowClientsActions } from '../Component/ShowClientsActions';
// import { AssignLeadsModal } from './AssignLeadsModal';
// import { UpdateClientAction } from '../Redux/Actions/UsersAction';
// import QuickFilterModalForMarketer from './QuickFilterModalForMarketer';
// import { LeadDuplicationModal } from './LeadDuplicationModal';
// import { ShowClientsActionsAdvanced } from './ShowClientsActionsAdvanced';

// // PhoneCell Component
// const PhoneCell = React.memo(({ user, mode }) => {
//   const [showFullNumber, setShowFullNumber] = useState(false);

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'left',
//         gap: 0.5,
//       }}
//       onMouseEnter={() => setShowFullNumber(true)}
//       onMouseLeave={() => setShowFullNumber(false)}
//     >
//       {user.phone && (
//         <Typography
//           variant="body2"
//           sx={{
//             cursor: 'pointer',
//             padding: '4px 8px',
//             borderRadius: '4px',
//             backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//             transition: 'all 0.2s ease-in-out',
//             fontFamily: 'monospace',
//             fontWeight: '500',
//             minHeight: '32px',
//             display: 'flex',
//             alignItems: 'left',
//             justifyContent: 'left',
//             minWidth: '80px',
//             '&:hover': {
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
//             },
//           }}
//         >
//           {showFullNumber ? user.phone : `${user.phone.substring(0, 5)}...`}
//         </Typography>
//       )}

//       <Box sx={{ display: 'flex', alignItems: 'left', gap: 1 }}>
//         <IconButton
//           size="small"
//           onClick={(e) => {
//             e.stopPropagation();
//             if (user.phone) {
//               const whatsappUrl = `https://wa.me/${user.phone.replace(/\D/g, '')}`;
//               window.open(whatsappUrl, '_blank');
//             }
//           }}
//           sx={{
//             color: '#25D366',
//             backgroundColor:
//               mode === 'dark' ? 'rgba(37, 211, 102, 0.1)' : 'rgba(37, 211, 102, 0.1)',
//             '&:hover': {
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(37, 211, 102, 0.2)' : 'rgba(37, 211, 102, 0.2)',
//             },
//           }}
//           disabled={!user.phone}
//         >
//           <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//             <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.189-1.248-6.189-3.515-8.452" />
//           </svg>
//         </IconButton>

//         <IconButton
//           size="small"
//           onClick={(e) => {
//             e.stopPropagation();
//             if (user.phone) {
//               window.open(`tel:${user.phone}`);
//             }
//           }}
//           sx={{
//             color: '#1976d2',
//             backgroundColor:
//               mode === 'dark' ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.1)',
//             '&:hover': {
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(25, 118, 210, 0.2)' : 'rgba(25, 118,210, 0.2)',
//             },
//           }}
//           disabled={!user.phone}
//         >
//           <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//             <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
//           </svg>
//         </IconButton>
//       </Box>
//     </Box>
//   );
// });

// export const AllLeadsForMarketerPage = () => {
//   const theme = useMuiTheme();
//   const mode = theme.palette.mode;
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
//   const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
//   const dispatch = useDispatch();
//   const location = useLocation();

//   // State Management
//   const [userlogin, setUserlogin] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [stageFilter, setStageFilter] = useState('');
//   const [sortField, setSortField] = useState('createdAt');
//   const [sortDirection, setSortDirection] = useState('desc');
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [leadDetailsOpen, setLeadDetailsOpen] = useState(false);
//   const [leadMenuAnchor, setLeadMenuAnchor] = useState(null);
//   const [selectedLeadForMenu, setSelectedLeadForMenu] = useState(null);
//   const [tableSettingsOpen, setTableSettingsOpen] = useState(false);
//   const [showAssignModal, setShowAssignModal] = useState(false);
//   const [selectedLeads, setSelectedLeads] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [hoveredLeadId, setHoveredLeadId] = useState(null);
//   const [loadingComments, setLoadingComments] = useState(false);

//   // New States for Features
//   const [openimport2, setopenimport2] = useState(false);
//   const [fileimport2, setFileimport2] = useState(null);
//   const [previewData, setPreviewData] = useState([]);
//   const [loadingimprt2, setLoadingimort2] = useState(false);
//   const [resultimport2, setResultimport2] = useState(null);
//   const [errorimport2, setErrorimport2] = useState(null);
//   const [quickFilterOpen, setQuickFilterOpen] = useState(false);
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [filteredUsers, setFilteredUsers] = useState([]);
//   const [searchType, setSearchType] = useState('keyword');

//   // State for navbar search
//   const [searchword, setSearchword] = useState(localStorage.getItem('searchMarketerstorage') || '');

//   const downloadExcelTemplate = () => {
//     // إنشاء البيانات الأساسية للقالب
//     const templateData = [
//       {
//         name: 'Ahmed Hassan',
//         phone: '+971501234567',
//         email: 'ahmed@email.com',
//         project_name: 'Dubai Hills',
//         sales_name: 'Mohamed Ali',
//         chanel_name: '008 | A',
//         communication_way: 'Call',
//         stage_name: 'Follow UP',
//         campaign_name: 'Summer Campaign',
//         addby_name: 'Joun',
//         updatedby_name: 'Joun',
//         budget: '1500000',
//         leedtype: 'Cold',
//         stagedateupdated: '2024-03-15',
//         dayonly: '2024-03-15',
//         last_stage_date_updated: '2024-03-15',
//         creation_date: '2024-01-10',
//         Last_Date_Assigned: '2024-03-01',
//         // الحقول الجديدة للأسئلة والإجابات
//         question1_text: 'How did you hear about us?',
//         question1_answer: 'Facebook',
//         question2_text: 'Preferred budget range?',
//         question2_answer: '1.5M - 2M AED',
//         question3_text: 'Interested in payment plan?',
//         question3_answer: 'Yes',
//         question4_text: 'Preferred location?',
//         question4_answer: 'Dubai Hills',
//         question5_text: 'Ready to proceed?',
//         question5_answer: 'Need more information',
//       },
//       {
//         name: 'Sarah Johnson',
//         phone: '+971502345678',
//         email: 'sarah@email.com',
//         project_name: 'Palm Jumeirah',
//         sales_name: 'Fatima Ahmed',
//         chanel_name: '005 |A',
//         communication_way: 'Whatsapp',
//         stage_name: 'Pending',
//         campaign_name: 'Luxury Homes',
//         addby_name: 'Johan De',
//         updatedby_name: 'Johan De',
//         budget: '2800000',
//         leedtype: 'Cold',
//         stagedateupdated: '2024-03-10',
//         dayonly: '2024-03-10',
//         last_stage_date_updated: '2024-03-10',
//         creation_date: '2024-01-25',
//         Last_Date_Assigned: '2024-02-15',
//         // الحقول الجديدة للأسئلة والإجابات
//         question1_text: 'How did you hear about us?',
//         question1_answer: 'Facebook',
//         question2_text: 'Preferred budget range?',
//         question2_answer: '1.5M - 2M AED',
//         question3_text: 'Interested in payment plan?',
//         question3_answer: 'Yes',
//         question4_text: 'Preferred location?',
//         question4_answer: 'Dubai Hills',
//         question5_text: 'Ready to proceed?',
//         question5_answer: 'Need more information',
//       },
//     ];

//     // إنشاء ورقة Excel
//     const ws = XLSX.utils.json_to_sheet(templateData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Leads Template');

//     // تنزيل الملف
//     XLSX.writeFile(wb, 'Leads_Import_Template.xlsx');

//     // إذا لم يكن XLSX متاحاً، عرض رسالة
//     console.log('Template downloaded successfully');

//     // يمكنك أيضاً استخدام:
//     // window.open('/api/download-template', '_blank');
//   };

//   // Get user from localStorage
//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem('user'));
//     if (user) {
//       setUserlogin(user);
//     }
//   }, []);

//   // Listen for navbar search updates
//   useEffect(() => {
//     const handleSearchUpdate = () => {
//       const newSearch = localStorage.getItem('searchMarketerstorage') || '';
//       setSearchword(newSearch);
//       setSearchTerm(newSearch);
//       setPage(0);
//     };

//     window.addEventListener('searchMarketerUpdated', handleSearchUpdate);
//     return () => window.removeEventListener('searchMarketerUpdated', handleSearchUpdate);
//   }, []);

//   // Redux State
//   const Leads = useSelector((state) => state.AllRoleData.Get_Leads_For_Marketer);
//   const leadsData = Leads?.data || [];
//   const pagination = Leads?.pagination || {};

//   // Table Configuration
//   const defaultTableConfig = {
//     columns: [
//       { key: 'selection', label: '', visible: true, width: 60 },
//       { key: 'duplicate', label: 'Duplicate', visible: true, width: 120 },

//       { key: 'name', label: 'Name', visible: true, width: 180 },
//       { key: 'phone', label: 'Phone', visible: true, width: 140 },
//       { key: 'developer', label: 'Developer', visible: true, width: 120 },
//       { key: 'project', label: 'Project', visible: true, width: 150 },
//       { key: 'campaign', label: 'Campaign', visible: true, width: 150 },
//       { key: 'channel', label: 'Channel', visible: true, width: 120 },
//       { key: 'sales', label: 'Sales', visible: true, width: 150 },
//       { key: 'lastComment', label: 'Last Comment', visible: true, width: 80 },
//       { key: 'stage', label: 'Stage', visible: true, width: 180 },
//       { key: 'creationDate', label: 'Creation Date', visible: true, width: 180 },
//       { key: 'actions', label: 'Actions', visible: true, width: 120 },
//     ],
//     columnOrder: [
//       'selection',
//       'duplicate',
//       'name',
//       'phone',
//       'developer',
//       'project',
//       'campaign',
//       'channel',
//       'sales',
//       'lastComment',
//       'stage',
//       'creationDate',
//       'actions',
//     ],
//     whiteHeaders: true,
//   };

//   const [tableConfig, setTableConfig] = useState(() => {
//     const savedConfig = localStorage.getItem('marketerTableConfig');
//     return savedConfig ? JSON.parse(savedConfig) : defaultTableConfig;
//   });

//   // Save table config to localStorage
//   useEffect(() => {
//     localStorage.setItem('marketerTableConfig', JSON.stringify(tableConfig));
//   }, [tableConfig]);

//   const [currentStageFromUrl, setCurrentStageFromUrl] = useState('');

//   useEffect(() => {
//     const searchParams = new URLSearchParams(location.search);
//     const stageId = searchParams.get('stage');

//     // 🔥 FIX: إعادة تعيين stage فقط إذا كان مختلفًا عن القيمة الحالية
//     if (stageId !== currentStageFromUrl) {
//       console.log('🎯 URL stage changed to:', stageId);
//       setCurrentStageFromUrl(stageId || '');
//     }
//   }, [location.search]); // ⚠️ لا تضيف currentStageFromUrl هنا

//   // 🔍 دالة ذكية للبحث تعتمد على نوع الـ input - نفس دالة الـ Admin
//   const getSearchQuery = (search) => {
//     if (!search) return '';

//     const cleanSearch = search.trim();

//     // إذا كان إيميل واضح
//     if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanSearch)) {
//       console.log('📧 Detected email search:', cleanSearch);
//       return `email=${encodeURIComponent(cleanSearch)}`;
//     }

//     // إذا كان رقم تليفون
//     if (/^\+?[\d\s\-\(\)]+$/.test(cleanSearch)) {
//       console.log('📱 Detected phone search:', cleanSearch);
//       return `keyword=${encodeURIComponent(cleanSearch)}`;
//     }

//     // أي شيء آخر نستخدم keyword علشان يدور في name و phone
//     console.log('🔤 Detected keyword search (name/phone/email):', cleanSearch);
//     return `keyword=${encodeURIComponent(cleanSearch)}`;
//   };

//   // دالة لاستخراج الـ IDs من المصفوفات
//   const extractIds = (items) => {
//     if (!items || !Array.isArray(items) || items.length === 0) return '';

//     return items
//       .map((item) => {
//         if (typeof item === 'string') return item;
//         if (typeof item === 'object' && item !== null) {
//           return item.id || item._id || item.value || item.name || JSON.stringify(item);
//         }
//         return null;
//       })
//       .filter((id) => id && id !== '' && id !== 'null' && id !== 'undefined' && id !== '{}')
//       .join(',');
//   };

//   // Enhanced Fetch Leads Function
//   const fetchLeads = useCallback(
//     async (search = '') => {
//       if (!userlogin?.data?.email) return;

//       setLoading(true);
//       try {
//         // ✅ الأساسي: إيميل المستخدم + active leads
//         let query = `email=${userlogin.data.email}&leadisactive=true&page=${page + 1}&limit=${rowsPerPage}&sort=${sortDirection === 'desc' ? '-' : ''}${sortField}`;

//         console.log('🔍 Initial query:', query);
//         console.log('🔍 Search term:', search);

//         // 🔥 FIX: البحث الذكي بناءً على نوع المدخلات
//         if (search) {
//           const cleanSearch = search.trim();

//           // 1. إذا كان إيميل واضح (باحث عن إيميل الليد)
//           if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanSearch)) {
//             console.log('📧 Detected lead email search:', cleanSearch);
//             query += `&leadEmail=${encodeURIComponent(cleanSearch)}`;
//           }
//           // 2. إذا كان رقم تليفون
//           else if (/^[\+]?[0-9\s\-\(\)\.]+$/.test(cleanSearch)) {
//             console.log('📱 Detected lead phone search:', cleanSearch);
//             query += `&phone=${encodeURIComponent(cleanSearch)}`;
//           }
//           // 3. إذا كان اسم (قد يحتوي على مسافات)
//           else {
//             console.log('👤 Detected lead name search:', cleanSearch);
//             query += `&leadName=${encodeURIComponent(cleanSearch)}`;
//           }
//         }

//         // 🎯 إضافة الـ stage ID إذا موجود في الـ URL (من Quick Numbers)
//         // 🔥 FIX: استخدام stage ID فقط إذا كان موجودًا ولم يتم إعادة تعيينه
//         if (currentStageFromUrl) {
//           query += `&stage=${encodeURIComponent(currentStageFromUrl)}`;
//           console.log('🎯 Stage filter active:', currentStageFromUrl);
//         }
//         // 🎛️ تطبيق الفلاتر المخزنة
//         if (appliedFilters && Object.keys(appliedFilters).length > 0) {
//           console.log('🎯 Applying stored filters:', appliedFilters);

//           const multiValueFilters = [
//             { key: 'stage', param: 'stage' },
//             { key: 'sales', param: 'sales' },
//             { key: 'chanel', param: 'chanel' },
//             { key: 'campaign', param: 'campaign' },
//             { key: 'project', param: 'project' },
//             { key: 'developer', param: 'developer' },
//             { key: 'oldstage', param: 'oldstage' },
//             { key: 'assignedTo', param: 'assignedTo' },
//             { key: 'assignedFrom', param: 'assignedFrom' },
//           ];

//           multiValueFilters.forEach(({ key, param }) => {
//             if (appliedFilters[key] && appliedFilters[key].length > 0) {
//               const ids = extractIds(appliedFilters[key]);
//               if (ids) {
//                 query += `&${param}=${encodeURIComponent(ids)}`;
//               }
//             }
//           });

//           // فلاتر التاريخ
//           if (appliedFilters.createdAt) {
//             if (appliedFilters.createdAt.from) {
//               query += `&createdFrom=${encodeURIComponent(appliedFilters.createdAt.from)}`;
//             }
//             if (appliedFilters.createdAt.to) {
//               query += `&createdTo=${encodeURIComponent(appliedFilters.createdAt.to)}`;
//             }
//           }

//           // فلتر الـ budget
//           if (appliedFilters.budget && appliedFilters.budget !== '') {
//             query += `&budget=${encodeURIComponent(appliedFilters.budget)}`;
//           }

//           // فلتر stage date
//           if (appliedFilters.stagedateupdated) {
//             if (appliedFilters.stagedateupdated.from) {
//               query += `&stageDateFrom=${encodeURIComponent(appliedFilters.stagedateupdated.from)}`;
//             }
//             if (appliedFilters.stagedateupdated.to) {
//               query += `&stageDateTo=${encodeURIComponent(appliedFilters.stagedateupdated.to)}`;
//             }
//           }
//         }

//         // 🔄 إضافة الـ duplicates إذا موجود في الـ URL
//         const searchParams = new URLSearchParams(location.search);
//         const duplicates = searchParams.get('duplicates');
//         const ignoreduplicate = searchParams.get('ignoreduplicate');

//         if (duplicates === 'true') {
//           query += `&duplicates=true&ignoreduplicate=${ignoreduplicate || 'true'}`;
//           console.log('🔄 Loading duplicates with ignoreduplicate flag');
//         }

//         console.log('📦 Final API query:', query);

//         // 🔥 استخدام الـ action المناسب
//         await dispatch(Get_All_Leads_By_Email_User_Marketer_email_Action2(query));
//       } catch (error) {
//         console.error('Error fetching leads:', error);

//         // رسائل خطأ محددة
//         if (error.response?.status === 404) {
//           Notify('info', 'No leads found matching your search criteria', 'info');
//         } else if (error.response?.status === 400) {
//           Notify('warning', 'Invalid search parameters. Please check your input.', 'warning');
//         } else {
//           Notify('error', 'Failed to fetch leads. Please try again.', 'error');
//         }
//       } finally {
//         setLoading(false);
//       }
//     },
//     [
//       userlogin,
//       page,
//       rowsPerPage,
//       sortField,
//       sortDirection,
//       currentStageFromUrl, // ✅ أضف هذا
//       appliedFilters,
//       location.search,
//       dispatch,
//       extractIds, // ✅ أضف هذا إذا كانت دالة منفصلة
//     ],
//   );

//   // Initial fetch وتحديث البيانات عند تغيير الحالات
//   useEffect(() => {
//     console.log('🔄 Main fetch triggered:', {
//       hasUser: !!userlogin?.data?.email,
//       page,
//       rowsPerPage,
//       searchTerm,
//       stage: currentStageFromUrl,
//     });

//     if (userlogin?.data?.email) {
//       fetchLeads(searchTerm);
//     }
//   }, [
//     userlogin,
//     page,
//     rowsPerPage,
//     searchTerm,
//     currentStageFromUrl, // ⚠️ أضف هذا مرة أخرى
//     sortField,
//     sortDirection,
//   ]);

//   // ⭐ إضافة useEffect منفصل للتعامل مع stage filter
//   useEffect(() => {
//     if (currentStageFromUrl && userlogin?.data?.email) {
//       console.log('🎯 Stage filter changed, fetching with stage:', currentStageFromUrl);
//       setPage(0); // العودة للصفحة الأولى
//       fetchLeads(searchTerm);
//     }
//   }, [currentStageFromUrl]); // ⬅️ هذا فقط يعتمد على stage

//   // ⭐ إضافة useEffect منفصل للتعامل مع appliedFilters
//   useEffect(() => {
//     if (Object.keys(appliedFilters).length > 0 && userlogin?.data?.email) {
//       console.log('🎛️ Applied filters changed, fetching with filters');
//       setPage(0); // العودة للصفحة الأولى
//       fetchLeads(searchTerm);
//     }
//   }, [appliedFilters]);

//   // Handle search - مشابه للـ Admin
//   const handleSearch = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);

//     // تحديث localStorage للبحث من الناف بار
//     localStorage.setItem('searchMarketerstorage', value);
//     window.dispatchEvent(new Event('searchMarketerUpdated'));

//     // إعادة تعيين الصفحة
//     setPage(0);

//     // عرض رسالة توضيحية لنوع البحث
//     if (value.trim()) {
//       const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
//       const isPhone = /^[\+]?[0-9\s\-\(\)\.]+$/.test(value);

//       if (isEmail) {
//         console.log('🔍 Searching lead by email:', value);
//         Notify('info', 'Searching leads by email address', 'info');
//       } else if (isPhone) {
//         console.log('🔍 Searching lead by phone:', value);
//         Notify('info', 'Searching leads by phone number', 'info');
//       } else {
//         console.log('🔍 Searching lead by name:', value);
//         Notify('info', 'Searching leads by name', 'info');
//       }
//     }
//   };

//   // =======================================
//   // comment icon click
//   // أضف state للـ clicked
//   // const [clickedLeadId, setClickedLeadId] = useState(null);
//   // const handleIconClick = (leadId) => {
//   //   // إذا مفتوح بالفعل، أغلقه، وإلا افتحه
//   //   setClickedLeadId(prev => prev === leadId ? null : leadId);
//   // };

//   // const handleCloseTooltip = () => {
//   //   setClickedLeadId(null);
//   // };

//   // useEffect(() => {
//   //   const handleClickOutside = (event) => {
//   //     // أغلق الـ tooltip إذا المستخدم داس في أي مكان خارج
//   //     if (clickedLeadId && !event.target.closest('.comment-tooltip-container')) {
//   //       setClickedLeadId(null);
//   //     }
//   //   };

//   //   document.addEventListener('mousedown', handleClickOutside);
//   //   return () => {
//   //     document.removeEventListener('mousedown', handleClickOutside);
//   //   };
//   // }, [clickedLeadId]);

//   // =================================

//   // Handle clear search
//   const handleClearSearch = () => {
//     setSearchTerm('');
//     setSearchword('');
//     localStorage.removeItem('searchMarketerstorage');
//     window.dispatchEvent(new Event('searchMarketerUpdated'));
//     setPage(0);
//     Notify('info', 'Search cleared', 'info');
//   };

//   // Handle pagination
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // Handle sort
//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
//     } else {
//       setSortField(field);
//       setSortDirection('desc');
//     }
//   };

//   // Handle selection
//   const handleSelectLead = (leadId) => {
//     setSelectedLeads((prev) => {
//       if (prev.includes(leadId)) {
//         return prev.filter((id) => id !== leadId);
//       } else {
//         return [...prev, leadId];
//       }
//     });
//   };

//   const handleSelectAll = () => {
//     if (selectAll) {
//       setSelectedLeads([]);
//       setSelectAll(false);
//     } else {
//       const allLeadIds = leadsData.map((lead) => lead._id);
//       setSelectedLeads(allLeadIds);
//       setSelectAll(true);
//     }
//   };

//   const isLeadSelected = (leadId) => {
//     return selectedLeads.includes(leadId);
//   };

//   // Handle assign leads
//   const handleAssignClick = () => {
//     if (selectedLeads.length === 0) {
//       Notify('warning', 'Please select at least one lead to assign', 'warning');
//       return;
//     }
//     setShowAssignModal(true);
//   };

//   // Handle refresh
//   const handleRefresh = () => {
//     console.log('🔄 Manual refresh triggered');

//     // إعادة تعيين stage filter
//     if (currentStageFromUrl) {
//       setCurrentStageFromUrl('');
//       // تنظيف الـ URL
//       const url = new URL(window.location);
//       url.searchParams.delete('stage');
//       window.history.replaceState({}, '', url);
//     }

//     // إعادة تعيين البحث
//     if (searchTerm) {
//       setSearchTerm('');
//       localStorage.removeItem('searchMarketerstorage');
//     }

//     // إعادة تعيين الفلاتر
//     if (Object.keys(appliedFilters).length > 0) {
//       setAppliedFilters({});
//     }

//     // إعادة تعيين الصفحة
//     setPage(0);

//     // جلب البيانات الجديدة بدون stage
//     fetchLeads('', true); // forceStageReset = true

//     Notify('info', 'Refreshing data...', 'info');
//   };

//   // Handle view lead details
//   const handleViewLeadDetails = (lead) => {
//     setSelectedLead(lead);
//     setLeadDetailsOpen(true);
//   };

//   // Handle lead menu
//   const handleLeadMenuOpen = (event, lead) => {
//     setSelectedLeadForMenu(lead);
//     setLeadMenuAnchor(event.currentTarget);
//   };

//   const handleLeadMenuClose = () => {
//     setLeadMenuAnchor(null);
//     setSelectedLeadForMenu(null);
//   };

//   // Handle export
//   const handleExportLeads = () => {
//     if (leadsData.length === 0) {
//       Notify('warning', 'No leads to export', 'warning');
//       return;
//     }

//     const dataToExport = leadsData.map((lead) => ({
//       Name: lead.name || '',
//       Email: lead.email || '',
//       Phone: lead.phone || '',
//       Project: lead.project?.name || 'N/A',
//       Developer: lead.project?.developer?.name || 'N/A',
//       Campaign: lead.campaign?.CampainName || 'N/A',
//       Channel: lead.chanel?.name || 'N/A',
//       'Sales Person': lead.sales?.name || 'N/A',
//       Stage: lead.stage?.name || 'N/A',
//       'Stage Date': lead.stagedateupdated
//         ? moment(lead.stagedateupdated).format('DD/MM/YYYY h:mm A')
//         : '',
//       Status: lead.leadisactive === 'true' ? 'Active' : 'Inactive',
//       Notes: lead.notes || '',
//       Budget: lead.budget || '',
//       'Assigned To': lead.sales?.name || '',
//       'Assigned From': lead.assignfrom?.name || '',
//       'Added By': lead.addby?.name || 'N/A',
//       'Creation Date': lead.date ? moment(lead.date).format('DD/MM/YYYY h:mm A') : '',
//       'Last Comment': lead.lastComment?.firstcomment?.text || '',
//       'Action Plan': lead.lastComment?.secondcomment?.text || '',
//     }));

//     const ws = XLSX.utils.json_to_sheet(dataToExport);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'My Leads');

//     const fileName = `My_Leads_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`;
//     XLSX.writeFile(wb, fileName);

//     Notify('success', `Exported ${leadsData.length} leads to Excel!`, 'success');
//   };

//   // Handle export with all comments
//   const exportFilteredLeadsWithAllComments = async () => {
//     if (!leadsData || leadsData.length === 0) {
//       Notify('warning', 'No leads to export.', 'warning');
//       return;
//     }

//     Notify('info', 'Preparing data... This may take a moment.', 'info');

//     try {
//       const response = await axios.get(`${db_url}api/v1/Action`);
//       const allActions = response.data.data;

//       const dataToExport = leadsData.map((lead) => {
//         const leadActions = allActions.filter((action) => action.leed?._id === lead._id);
//         const allLeadComments = leadActions.flatMap((action) => action.Comments || []);
//         const sortedComments = allLeadComments.sort(
//           (a, b) => new Date(a.stageDate || a.createdAt) - new Date(b.stageDate || b.createdAt),
//         );

//         const formattedComments = sortedComments
//           .map((comment, index) => {
//             const commentDate = moment(comment.stageDate || comment.createdAt).format(
//               'DD/MM/YYYY h:mm A',
//             );
//             const stageName = comment.stage?.name || 'N/A';
//             const salesName = comment.sales?.name || 'N/A';
//             const firstComment = comment.firstcomment?.text || 'No text';
//             const secondComment = comment.secondcomment?.text || 'No text';

//             return `(${index + 1}) [${commentDate}] - [Stage: ${stageName}] - [By: ${salesName}]\nComment: ${firstComment}\nNext Action: ${secondComment}\n------------------`;
//           })
//           .join('\n\n');

//         return {
//           Name: lead.name || '',
//           Email: lead.email || '',
//           Phone: lead.phone || '',
//           'Phone 2': lead.phonenumber2 || '',
//           WhatsApp: lead.whatsappnumber || '',
//           Project: lead.project?.name || 'N/A',
//           Developer: lead.project?.developer?.name || 'N/A',
//           Campaign: lead.campaign?.CampainName || 'N/A',
//           Channel: lead.chanel?.name || 'N/A',
//           'Sales Person': lead.sales?.name || 'N/A',
//           Stage: lead.stage?.name || 'N/A',
//           'Stage Date': lead.stagedateupdated
//             ? moment(lead.stagedateupdated).format('DD/MM/YYYY h:mm A')
//             : '',
//           Status: lead.leadisactive === 'true' ? 'Active' : 'Inactive',
//           Notes: lead.notes || '',
//           Budget: lead.budget || '',
//           'Assigned To': lead.sales?.name || '',
//           'Assigned From': lead.assignfrom?.name || '',
//           'Added By': lead.addby?.name || 'N/A',
//           'Creation Date': lead.date ? moment(lead.date).format('DD/MM/YYYY h:mm A') : '',
//           'Total Comments': sortedComments.length,
//           'All Comments': formattedComments || 'No Comments Found',
//         };
//       });

//       const worksheet = XLSX.utils.json_to_sheet(dataToExport);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads with All Comments');

//       const wscols = [
//         { wch: 20 },
//         { wch: 25 },
//         { wch: 15 },
//         { wch: 15 },
//         { wch: 15 },
//         { wch: 20 },
//         { wch: 20 },
//         { wch: 20 },
//         { wch: 15 },
//         { wch: 20 },
//         { wch: 15 },
//         { wch: 20 },
//         { wch: 10 },
//         { wch: 30 },
//         { wch: 15 },
//         { wch: 20 },
//         { wch: 20 },
//         { wch: 20 },
//         { wch: 20 },
//         { wch: 10 },
//         { wch: 100 },
//       ];

//       worksheet['!cols'] = wscols;

//       const fileName = `My_Leads_With_All_Comments_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`;
//       XLSX.writeFile(workbook, fileName);

//       Notify('success', `Exported ${leadsData.length} leads with all comments!`, 'success');
//     } catch (error) {
//       console.error('Export failed:', error);
//       Notify('error', 'Failed to export data', 'error');
//     }
//   };

//   // Handle import file select
//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setFileimport2(file);
//     setResultimport2(null);
//     setErrorimport2(null);

//     const reader = new FileReader();
//     reader.onload = async (e) => {
//       const data = e.target.result;
//       const workbook = await XLSX.readAsync(data);
//       const sheet = workbook.Sheets[workbook.SheetNames[0]];
//       const json = XLSX.utils.sheet_to_json(sheet);
//       setPreviewData(json);
//     };
//     reader.readAsBinaryString(file);
//   };

//   const [activeTab, setActiveTab] = useState('settings');
//   const [isDataCenterImport, setIsDataCenterImport] = useState(true);

//   // Handle import upload
//   // const onUploadimportleads2 = async () => {
//   //   if (!fileimport2) {
//   //     Notify('warning', 'Please select a file first', 'warning');
//   //     return;
//   //   }

//   //   const formData = new FormData();
//   //   formData.append('file', fileimport2);

//   //   setLoadingimort2(true);
//   //   try {
//   //     const res = await axios.post(`${db_url}api/v1/users/import-leads`, formData, {
//   //       headers: {
//   //         'Content-Type': 'multipart/form-data',
//   //       },
//   //     });
//   //     setResultimport2(res.data);
//   //     Notify('success', 'Leads imported successfully!', 'success');

//   //     fetchLeads(searchTerm);

//   //   } catch (err) {
//   //     console.error('Import error:', err);
//   //     setErrorimport2(err.response?.data || { message: err.message });
//   //     Notify('error', 'Failed to import leads', 'error');
//   //   }
//   //   setLoadingimort2(false);
//   // };

//   const onUploadimportleads2 = async () => {
//     if (!fileimport2) {
//       Notify('warning', 'Please select an Excel file first', 'warning');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', fileimport2);
//     // أضف قيمة الـ Switch
//     formData.append('importInDataCenter', isDataCenterImport);

//     setLoadingimort2(true);
//     try {
//       const res = await axios.post(`${db_url}api/v1/users/import-leads`, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });

//       setResultimport2(res.data);

//       // إظهار رسالة نجاح
//       Notify(
//         'success',
//         `✅ ${res.data.insertedCount} leads imported successfully to ${isDataCenterImport ? 'Data Center' : 'Original Leads'}!`,
//         'success',
//       );

//       // إغلاق الـ Modal بعد ثانيتين
//       setTimeout(() => {
//         handleCloseimport2();
//       }, 2000);
//     } catch (err) {
//       const errorMsg = err.response?.data?.message || err.message || 'Import failed';
//       setErrorimport2(errorMsg);
//       Notify('error', `❌ Import failed: ${errorMsg}`, 'error');
//     }
//     setLoadingimort2(false);
//     //  get(1, itemsPerPage, searchQuery);
//   };

//   const handleOpenimport2 = () => setopenimport2(true);
//   const handleCloseimport2 = () => {
//     setopenimport2(false);
//     setFileimport2(null);
//     setPreviewData([]);
//     setResultimport2(null);
//     setErrorimport2(null);
//   };

//   // Handle quick filters
//   const handleApplyFilters = (filters) => {
//     console.log('🎯 Received filters:', filters);

//     const cleanedFilters = {
//       budget: filters.budget || '',
//       stage: filters.stage || [],
//       oldstage: filters.oldstage || [],
//       sales: filters.sales || [],
//       chanel: filters.chanel || [],
//       campaign: filters.campaign || [],
//       project: filters.project || [],
//       developer: filters.developer || [],
//       assignedTo: filters.assignedTo || [],
//       createdAt: filters.createdAt || { from: null, to: null },
//       stagedateupdated: filters.stagedateupdated || { from: null, to: null },
//     };

//     setAppliedFilters(cleanedFilters);
//     setPage(0);
//     handleQuickFilterClose();
//   };

//   // Handle clear all filters
//   const handleClearFilters = () => {
//     setAppliedFilters({});
//     setPage(0);
//     Notify('info', 'All filters cleared', 'info');
//   };

//   const handleQuickFilterOpen = () => setQuickFilterOpen(true);
//   const handleQuickFilterClose = () => setQuickFilterOpen(false);

//   // Helper functions
//   const getStatusColor = (status) => {
//     return status === 'true' ? 'success' : 'error';
//   };

//   const getStageColor = (stageName) => {
//     const stageColors = {
//       New: 'primary',
//       Contacted: 'info',
//       Qualified: 'success',
//       Proposal: 'warning',
//       Negotiation: 'secondary',
//       'Closed Won': 'success',
//       'Closed Lost': 'error',
//       'No Answer': 'default',
//       'Follow Up': 'info',
//       'No Stage': 'default',
//     };
//     return stageColors[stageName] || 'default';
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     try {
//       return moment(dateString).format('DD/MM/YYYY HH:mm');
//     } catch {
//       return 'Invalid Date';
//     }
//   };

//   const getInitials = (name) => {
//     if (!name) return '?';
//     return name
//       .split(' ')
//       .map((n) => n[0])
//       .join('')
//       .toUpperCase()
//       .substring(0, 2);
//   };

//   const handleCommentHover = async (leadId) => {
//     setHoveredLeadId(leadId);
//     setLoadingComments(true);

//     try {
//       // هنا ممكن تجيب الكومنتس من الـ API إذا محتاج
//       // أو تستخدم البيانات اللي موجودة في lastComment
//       setLoadingComments(false);
//     } catch (error) {
//       console.error('Error loading comments:', error);
//       setLoadingComments(false);
//     }
//   };

//   const handleCommentLeave = () => {
//     setHoveredLeadId(null);
//     setLoadingComments(false);
//   };

//   // Table customization functions
//   const toggleColumnVisibility = (columnKey) => {
//     setTableConfig((prev) => ({
//       ...prev,
//       columns: prev.columns.map((col) =>
//         col.key === columnKey ? { ...col, visible: !col.visible } : col,
//       ),
//     }));
//   };

//   const updateColumnWidth = (columnKey, newWidth) => {
//     setTableConfig((prev) => ({
//       ...prev,
//       columns: prev.columns.map((col) =>
//         col.key === columnKey ? { ...col, width: Math.max(80, newWidth) } : col,
//       ),
//     }));
//   };

//   const resetToDefault = () => {
//     setTableConfig(defaultTableConfig);
//   };

//   const handleDragEnd = (result) => {
//     if (!result.destination) return;

//     const items = Array.from(tableConfig.columnOrder);
//     const [reorderedItem] = items.splice(result.source.index, 1);
//     items.splice(result.destination.index, 0, reorderedItem);

//     setTableConfig((prev) => ({
//       ...prev,
//       columnOrder: items,
//     }));
//   };

//   const toggleHeaderColors = () => {
//     setTableConfig((prev) => ({
//       ...prev,
//       whiteHeaders: !prev.whiteHeaders,
//     }));
//   };

//   const [duplicationModal, setDuplicationModal] = useState({
//     open: false,
//     leadId: null,
//     leadName: '',
//   });

//   const getVisibleColumns = () => {
//     return tableConfig.columnOrder
//       .map((key) => tableConfig.columns.find((col) => col.key === key))
//       .filter((col) => col && col.visible);
//   };

//   // Styled components
//   const StyledTableRow = styled(TableRow)(({ theme }) => ({
//     '&:nth-of-type(odd)': {
//       backgroundColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
//     },
//     '&:hover': {
//       backgroundColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.04)',
//     },
//   }));

//   // Cell renderers
//   const renderCell = (col, lead) => {
//     switch (col.key) {
//       case 'selection':
//         return (
//           <Checkbox
//             checked={isLeadSelected(lead._id)}
//             onChange={() => handleSelectLead(lead._id)}
//             sx={{
//               color: mode === 'dark' ? '#fff' : '#000',
//               '&.Mui-checked': {
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//               },
//             }}
//           />
//         );

//       //  case 'duplicate':
//       //       return (
//       //         <Box sx={{ textAlign: "center", padding: '8px 4px' }}>
//       //           <Box
//       //             onClick={() => {
//       //               console.log('Opening duplication modal for:', lead._id, lead.name);
//       //               setDuplicationModal({
//       //                 open: true,
//       //                 leadId: lead._id,
//       //                 leadName: lead.name
//       //               });
//       //             }}
//       //             sx={{
//       //               color: '#0f7687',
//       //               border: '1px solid #0f7687',
//       //               backgroundColor: mode === 'dark' ? 'rgba(15, 118, 135, 0.1)' : 'rgba(15, 118, 135, 0.05)',
//       //               padding: '4px 8px',
//       //               borderRadius: '16px',
//       //               fontSize: '12px',
//       //               fontWeight: '500',
//       //               cursor: 'pointer',
//       //               display: 'inline-block',
//       //               transition: 'all 0.2s ease-in-out',
//       //               '&:hover': {
//       //                 backgroundColor: mode === 'dark' ? 'rgba(15, 118, 135, 0.2)' : 'rgba(15, 118, 135, 0.1)',
//       //               }
//       //             }}
//       //           >
//       //             {lead.totalSubmissions ? `${lead.totalSubmissions} Register${lead.totalSubmissions > 1 ? 's' : ''}` : '0 Registers'}
//       //           </Box>
//       //         </Box>
//       //       );
//       case 'duplicate':
//         return (
//           <Box sx={{ textAlign: 'center', padding: '8px 4px' }}>
//             <Box
//               onClick={() => {
//                 console.log('Opening duplication modal for:', lead._id, lead.name);
//                 setDuplicationModal({
//                   open: true,
//                   leadId: lead._id,
//                   leadName: lead.name,
//                 });
//               }}
//               sx={{
//                 color: '#0f7687',
//                 border: '1px solid #0f7687',
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(15, 118, 135, 0.1)' : 'rgba(15, 118, 135, 0.05)',
//                 padding: '4px 8px',
//                 borderRadius: '16px',
//                 fontSize: '12px',
//                 fontWeight: '500',
//                 cursor: 'pointer',
//                 display: 'inline-block',
//                 transition: 'all 0.2s ease-in-out',
//                 '&:hover': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(15, 118, 135, 0.2)' : 'rgba(15, 118, 135, 0.1)',
//                 },
//               }}
//             >
//               {lead.totalSubmissions
//                 ? `${lead.totalSubmissions} Register${lead.totalSubmissions > 1 ? 's' : ''}`
//                 : '0 Registers'}
//             </Box>
//           </Box>
//         );

//       case 'name':
//         return (
//           <Box
//             sx={{ display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer' }}
//             onClick={() => setSelectedLead(lead)}
//           >
//             <Avatar
//               sx={{
//                 bgcolor: mode === 'dark' ? 'secondary.main' : 'primary.main',
//                 width: 40,
//                 height: 40,
//               }}
//             >
//               {getInitials(lead.name)}
//             </Avatar>
//             <Box>
//               <Typography variant="body1" fontWeight="medium">
//                 {lead.name}
//               </Typography>
//               <Typography variant="caption" color="text.secondary">
//                 {lead.email}
//               </Typography>
//             </Box>
//           </Box>
//         );

//       case 'phone':
//         return <PhoneCell user={lead} mode={mode} />;

//       case 'project':
//         return (
//           <Typography variant="body2" fontWeight="medium">
//             {lead.project?.name || 'N/A'}
//           </Typography>
//         );

//       case 'developer':
//         return <Typography variant="body2">{lead?.project?.developer?.name || 'N/A'}</Typography>;

//       // case 'campaign':
//       //   return (
//       //     <Typography variant="body2">
//       //       {lead.campaign?.CampainName || 'N/A'}
//       //     </Typography>
//       //   );
//       case 'campaign':
//         return (
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//             {/* Campaign Name */}
//             <Typography variant="body2">{lead.campaign?.CampainName || 'N/A'}</Typography>

//             {/* Action Chips - Only shown if there's a redirect link */}
//             {lead.campaign?.redirectLink && (
//               <Box sx={{ display: 'flex', gap: 0.5 }}>
//                 <Chip
//                   label="Copy Link"
//                   size="small"
//                   variant="outlined"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     navigator.clipboard.writeText(lead.campaign.redirectLink);
//                     Notify('success', 'Link copied', 'success');
//                   }}
//                   icon={<ContentCopyIcon sx={{ fontSize: '14px' }} />}
//                   sx={{
//                     height: '24px',
//                     fontSize: '0.7rem',
//                     '& .MuiChip-icon': {
//                       marginLeft: '4px',
//                       fontSize: '14px',
//                     },
//                   }}
//                 />

//                 <Chip
//                   label="Open"
//                   size="small"
//                   variant="outlined"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     window.open(lead.campaign.redirectLink, '_blank', 'noopener,noreferrer');
//                   }}
//                   icon={<OpenInNewIcon sx={{ fontSize: '14px' }} />}
//                   sx={{
//                     height: '24px',
//                     fontSize: '0.7rem',
//                     '& .MuiChip-icon': {
//                       marginLeft: '4px',
//                       fontSize: '14px',
//                     },
//                   }}
//                 />
//               </Box>
//             )}
//           </Box>
//         );
//       case 'channel':
//         return <Typography variant="body2">{lead.chanel?.name || 'N/A'}</Typography>;

//       case 'sales':
//         return (
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
//                 {lead.sales?.name || 'N/A'}
//               </Typography>
//               {lead.assign === true && (
//                 <Box sx={{ display: 'flex', gap: 0.5 }}>
//                   {[1, 2, 3].map((dot) => (
//                     <Box
//                       key={dot}
//                       sx={{
//                         width: 4,
//                         height: 4,
//                         borderRadius: '50%',
//                         backgroundColor: '#1976d2',
//                         animation: 'pulse 1.4s ease-in-out infinite',
//                         animationDelay: `${dot * 0.16}s`,
//                         '@keyframes pulse': {
//                           '0%, 80%, 100%': {
//                             transform: 'scale(0.8)',
//                             opacity: 0.5,
//                           },
//                           '40%': {
//                             transform: 'scale(1)',
//                             opacity: 1,
//                           },
//                         },
//                       }}
//                     />
//                   ))}
//                 </Box>
//               )}
//             </Box>
//             {lead.lastdateassign && (
//               <Typography
//                 variant="caption"
//                 sx={{
//                   color: '#666',
//                   fontSize: '11px',
//                 }}
//               >
//                 {moment(lead.lastdateassign).format('DD/MM/YYYY h:mm A')}
//               </Typography>
//             )}
//           </Box>
//         );

//       // case 'lastComment':
//       //   return (
//       //     <TableCell
//       //       key={col.key}
//       //       sx={{
//       //         width: `${col.width}px`,
//       //         minWidth: `${col.width}px`,
//       //         maxWidth: `${col.width}px`,
//       //         verticalAlign: 'top',
//       //         textAlign: 'left',
//       //         padding: '4px 8px'
//       //       }}
//       //       onMouseEnter={() => handleCommentHover(lead._id)}
//       //       onMouseLeave={handleCommentLeave}
//       //     >
//       //       <Tooltip
//       //         title={
//       //           hoveredLeadId === lead._id ? (
//       //             loadingComments ? (
//       //               <div style={{
//       //                 padding: '10px 16px',
//       //                 background: 'rgba(97, 97, 97, 0.9)',
//       //                 color: '#fff',
//       //                 borderRadius: '8px',
//       //                 fontSize: '13px',
//       //                 minWidth: '120px',
//       //                 textAlign: 'center'
//       //               }}>
//       //                 Loading...
//       //               </div>
//       //             ) : !lead.lastComment ? (
//       //               <div style={{
//       //                 padding: '10px 16px',
//       //                 background: 'rgba(97, 97, 97, 0.9)',
//       //                 color: '#fff',
//       //                 borderRadius: '8px',
//       //                 fontSize: '13px',
//       //                 minWidth: '120px',
//       //                 textAlign: 'center'
//       //               }}>
//       //                 No Comments
//       //               </div>
//       //             ) : (
//       //               <div style={{
//       //                 width: "450px",
//       //                 maxWidth: '90vw',
//       //                 padding: '20px',
//       //                 background: mode === 'dark' ? '#1e1e1e' : '#fff',
//       //                 borderRadius: '12px',
//       //                 color: mode === 'dark' ? '#fff' : '#333',
//       //                 fontSize: '14px',
//       //                 lineHeight: '1.5',
//       //                 border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                 boxShadow: '0 8px 30px rgba(0,0,0,0.12)'
//       //               }}>
//       //                 <div style={{
//       //                   display: 'flex',
//       //                   justifyContent: 'space-between',
//       //                   alignItems: 'flex-start',
//       //                   marginBottom: '16px',
//       //                   paddingBottom: '12px',
//       //                   borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0'
//       //                 }}>
//       //                   <div style={{
//       //                     display: 'flex',
//       //                     alignItems: 'center',
//       //                     gap: '12px'
//       //                   }}>
//       //                     <Avatar
//       //                       sx={{
//       //                         width: 40,
//       //                         height: 40,
//       //                         bgcolor: '#102dff',
//       //                         fontSize: '14px',
//       //                         fontWeight: 'bold'
//       //                       }}
//       //                     >
//       //                       {lead.lastComment.sales?.name ?
//       //                         lead.lastComment.sales.name.substring(0, 2).toUpperCase()
//       //                         : '?'
//       //                       }
//       //                     </Avatar>
//       //                     <div>
//       //                       <div style={{ fontWeight: '600', fontSize: '16px', marginBottom: '2px' }}>
//       //                         {lead.lastComment.sales?.name || "Unknown Sales"}
//       //                       </div>
//       //                       <div style={{ fontSize: '13px', color: mode === 'dark' ? '#ccc' : '#666' }}>
//       //                         {lead.lastComment.sales?.role || "Sales"}
//       //                       </div>
//       //                     </div>
//       //                   </div>

//       //                   {(lead.lastComment.stage || lead.stage) && (
//       //                     <div style={{ textAlign: 'right' }}>
//       //                       <div style={{
//       //                         fontWeight: '600',
//       //                         color: mode === 'dark' ? '#90caf9' : '#102dff',
//       //                         fontSize: '14px'
//       //                       }}>
//       //                         Stage: {lead.lastComment.stage?.name || lead.stage?.name || "Undefined"}
//       //                       </div>
//       //                       {lead.lastComment.stageDate && (
//       //                         <div style={{
//       //                           fontSize: '11px',
//       //                           color: mode === 'dark' ? '#999' : '#888',
//       //                           marginTop: '2px'
//       //                         }}>
//       //                           SD : | {new Date(lead.lastComment.stageDate).toLocaleString('en-US', {
//       //                             year: 'numeric',
//       //                             month: '2-digit',
//       //                             day: '2-digit',
//       //                             hour: '2-digit',
//       //                             minute: '2-digit',
//       //                             hour12: true
//       //                           })}
//       //                         </div>
//       //                       )}
//       //                     </div>
//       //                   )}
//       //                 </div>

//       //                 {lead.lastComment.firstcomment?.date && (
//       //                   <div style={{
//       //                     display: 'flex',
//       //                     justifyContent: 'center',
//       //                     alignItems: 'center',
//       //                     gap: '6px',
//       //                     fontSize: '12px',
//       //                     color: mode === 'dark' ? '#ccc' : '#666',
//       //                     marginBottom: '16px',
//       //                     padding: '6px 12px',
//       //                     background: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//       //                     borderRadius: '6px'
//       //                   }}>
//       //                     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                       <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
//       //                       <line x1="16" y1="2" x2="16" y2="6"></line>
//       //                       <line x1="8" y1="2" x2="8" y2="6"></line>
//       //                       <line x1="3" y1="10" x2="21" y2="10"></line>
//       //                     </svg>
//       //                     {new Date(lead.lastComment.firstcomment.date).toLocaleDateString() + ' • ' +
//       //                     new Date(lead.lastComment.firstcomment.date).toLocaleTimeString('en-US', {
//       //                       hour: '2-digit',
//       //                       minute: '2-digit',
//       //                       hour12: true
//       //                     })}
//       //                   </div>
//       //                 )}

//       //                 {lead.lastComment.firstcomment?.text && lead.lastComment.firstcomment.text !== '-' && (
//       //                   <div style={{ marginBottom: '16px' }}>
//       //                     <div style={{
//       //                       fontWeight: '600',
//       //                       color: mode === 'dark' ? '#90caf9' : '#102dff',
//       //                       fontSize: '14px',
//       //                       marginBottom: '8px',
//       //                       display: 'flex',
//       //                       alignItems: 'center',
//       //                       gap: '6px'
//       //                     }}>
//       //                       <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                         <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//       //                       </svg>
//       //                       Comment
//       //                     </div>
//       //                     <div style={{
//       //                       padding: '12px 16px',
//       //                       borderRadius: '8px',
//       //                       fontSize: '14px',
//       //                       lineHeight: '1.5',
//       //                       border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                       background: 'transparent'
//       //                     }}>
//       //                       {lead.lastComment.firstcomment.text}
//       //                     </div>
//       //                   </div>
//       //                 )}

//       //                 {lead.lastComment.secondcomment?.text && lead.lastComment.secondcomment.text !== '-' && (
//       //                   <div style={{ marginBottom: '12px' }}>
//       //                     <div style={{
//       //                       fontWeight: '600',
//       //                       color: mode === 'dark' ? '#4caf50' : '#2e7d32',
//       //                       fontSize: '14px',
//       //                       marginBottom: '8px',
//       //                       display: 'flex',
//       //                       alignItems: 'center',
//       //                       gap: '6px'
//       //                     }}>
//       //                       <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                         <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
//       //                         <polyline points="14,2 14,8 20,8"></polyline>
//       //                         <line x1="16" y1="13" x2="8" y2="13"></line>
//       //                         <line x1="16" y1="17" x2="8" y2="17"></line>
//       //                         <polyline points="10,9 9,9 8,9"></polyline>
//       //                       </svg>
//       //                       Action Plan
//       //                     </div>
//       //                     <div style={{
//       //                       padding: '12px 16px',
//       //                       borderRadius: '8px',
//       //                       fontSize: '14px',
//       //                       lineHeight: '1.5',
//       //                       border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                       background: 'transparent'
//       //                     }}>
//       //                       {lead.lastComment.secondcomment.text}
//       //                     </div>
//       //                   </div>
//       //                 )}

//       //                 <div style={{
//       //                   fontSize: '11px',
//       //                   color: mode === 'dark' ? '#999' : '#888',
//       //                   textAlign: 'center',
//       //                   marginTop: '16px',
//       //                   paddingTop: '12px',
//       //                   borderTop: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                   display: 'flex',
//       //                   alignItems: 'center',
//       //                   justifyContent: 'center',
//       //                   gap: '6px'
//       //                 }}>
//       //                   <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                     <circle cx="12" cy="12" r="10"></circle>
//       //                     <polyline points="12,6 12,12 16,14"></polyline>
//       //                   </svg>
//       //                   Last updated: {lead.lastComment.actionUpdatedAt ?
//       //                     new Date(lead.lastComment.actionUpdatedAt).toLocaleDateString('en-US', {
//       //                       year: 'numeric',
//       //                       month: '2-digit',
//       //                       day: '2-digit'
//       //                     })
//       //                     : 'Unknown'
//       //                   }
//       //                 </div>
//       //               </div>
//       //             )
//       //           ) : null
//       //         }
//       //         arrow
//       //         placement="left-start"
//       //         componentsProps={{
//       //           tooltip: {
//       //             sx: {
//       //               backgroundColor: 'transparent',
//       //               padding: 0,
//       //               m: 0,
//       //               boxShadow: 'none',
//       //               border: 'none',
//       //               overflow: 'visible',
//       //               maxWidth: 'none'
//       //             }
//       //           }
//       //         }}
//       //       >
//       //         <IconButton
//       //           size="small"
//       //           sx={{
//       //             color: lead.lastComment ?
//       //               (mode === 'dark' ? '#90caf9' : '#102dff') :
//       //               (mode === 'dark' ? '#666' : '#ccc'),
//       //             '&:hover': {
//       //               backgroundColor: mode === 'dark' ? 'rgba(144, 202, 249, 0.1)' : 'rgba(16, 45, 255, 0.1)',
//       //             }
//       //           }}
//       //         >
//       //           <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //             <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//       //           </svg>
//       //           {lead.lastComment && (
//       //             <Box
//       //               sx={{
//       //                 position: 'absolute',
//       //                 top: 4,
//       //                 right: 4,
//       //                 width: 6,
//       //                 height: 6,
//       //                 borderRadius: '50%',
//       //                 backgroundColor: mode === 'dark' ? '#4caf50' : '#2e7d32',
//       //               }}
//       //             />
//       //           )}
//       //         </IconButton>
//       //       </Tooltip>
//       //     </TableCell>
//       //   );

//       //     case 'lastComment':
//       // return (
//       //   <TableCell
//       //     key={col.key}
//       //     sx={{
//       //       width: `${col.width}px`,
//       //       minWidth: `${col.width}px`,
//       //       maxWidth: `${col.width}px`,
//       //       verticalAlign: 'top',
//       //       textAlign: 'left',
//       //       padding: '4px 8px'
//       //     }}
//       //     // أزل الـ mouse events
//       //     // onMouseEnter={() => handleCommentHover(user._id)}
//       //     // onMouseLeave={handleCommentLeave}
//       //   >
//       //     <Tooltip
//       //       title={
//       //         clickedLeadId === lead._id ? (
//       //           !lead.lastComment ? (
//       //             <div style={{
//       //               padding: '10px 16px',
//       //               background: 'rgba(97, 97, 97, 0.9)',
//       //               color: '#fff',
//       //               borderRadius: '8px',
//       //               fontSize: '13px',
//       //               minWidth: '120px',
//       //               textAlign: 'center'
//       //             }}>
//       //               No Comments
//       //             </div>
//       //           ) : (
//       //             <div style={{
//       //               width: "450px",
//       //               maxWidth: '90vw',
//       //               padding: '20px',
//       //               background: mode === 'dark' ? '#1e1e1e' : '#fff',
//       //               borderRadius: '12px',
//       //               color: mode === 'dark' ? '#fff' : '#333',
//       //               fontSize: '14px',
//       //               lineHeight: '1.5',
//       //               border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //               boxShadow: '0 8px 30px rgba(0,0,0,0.12)'
//       //             }}>
//       //               {/* Header - Sales Info + Stage */}
//       //               <div style={{
//       //                 display: 'flex',
//       //                 justifyContent: 'space-between',
//       //                 alignItems: 'flex-start',
//       //                 marginBottom: '16px',
//       //                 paddingBottom: '12px',
//       //                 borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0'
//       //               }}>
//       //                 {/* Sales Info - Avatar with first 2 letters */}
//       //                 <div style={{
//       //                   display: 'flex',
//       //                   alignItems: 'center',
//       //                   gap: '12px'
//       //                 }}>
//       //                   <Avatar
//       //                     sx={{
//       //                       width: 40,
//       //                       height: 40,
//       //                       bgcolor: '#102dff',
//       //                       fontSize: '14px',
//       //                       fontWeight: 'bold'
//       //                     }}
//       //                   >
//       //                     {lead.lastComment.sales?.name ?
//       //                       lead.lastComment.sales.name.substring(0, 2).toUpperCase()
//       //                       : '?'
//       //                     }
//       //                   </Avatar>
//       //                   <div>
//       //                     <div style={{ fontWeight: '600', fontSize: '16px', marginBottom: '2px' }}>
//       //                       {lead.lastComment.sales?.name || "Unknown Sales"}
//       //                     </div>
//       //                     <div style={{ fontSize: '13px', color: mode === 'dark' ? '#ccc' : '#666' }}>
//       //                       {lead.lastComment.sales?.role || "Sales"}
//       //                     </div>
//       //                   </div>
//       //                 </div>

//       //                 {/* Stage on the right - under sales name */}
//       //                 {(lead.lastComment.stage || lead.stage) && (
//       //                   <div style={{
//       //                     textAlign: 'right'
//       //                   }}>

//       //                     <div style={{
//       //                       fontWeight: '600',
//       //                       color: mode === 'dark' ? '#90caf9' : '#102dff',
//       //                       fontSize: '14px'
//       //                     }}>
//       //                       Stage: {lead.lastComment.stage?.name || lead.stage?.name || "Undefined"}
//       //                     </div>
//       //                     {(lead.lastComment.stageDate) && (
//       //                       <div style={{
//       //                         fontSize: '11px',
//       //                         color: mode === 'dark' ? '#999' : '#888',
//       //                         marginTop: '2px'
//       //                       }}>
//       //                         <span>
//       //                           SD : | {
//       //                             new Date(lead.lastComment.stageDate).toLocaleString('en-US', {
//       //                               year: 'numeric',
//       //                               month: '2-digit',
//       //                               day: '2-digit',
//       //                               hour: '2-digit',
//       //                               minute: '2-digit',
//       //                               hour12: true
//       //                             })
//       //                           }
//       //                         </span>
//       //                       </div>
//       //                     )}
//       //                   </div>
//       //                 )}
//       //               </div>

//       //               {/* Comment Date */}
//       //               {lead.lastComment.firstcomment?.date && (
//       //                 <div style={{
//       //                   display: 'flex',
//       //                   justifyContent: 'center',
//       //                   alignItems: 'center',
//       //                   gap: '6px',
//       //                   fontSize: '12px',
//       //                   color: mode === 'dark' ? '#ccc' : '#666',
//       //                   marginBottom: '16px',
//       //                   padding: '6px 12px',
//       //                   background: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//       //                   borderRadius: '6px'
//       //                 }}>
//       //                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                     <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
//       //                     <line x1="16" y1="2" x2="16" y2="6"></line>
//       //                     <line x1="8" y1="2" x2="8" y2="6"></line>
//       //                     <line x1="3" y1="10" x2="21" y2="10"></line>
//       //                   </svg>
//       //                   {new Date(lead.lastComment.firstcomment.date).toLocaleDateString() + ' • ' +
//       //                    new Date(lead.lastComment.firstcomment.date).toLocaleTimeString('en-US', {
//       //                      hour: '2-digit',
//       //                      minute: '2-digit',
//       //                      hour12: true
//       //                    })}
//       //                 </div>
//       //               )}

//       //               {/* First Comment (Comment) */}
//       //               {lead.lastComment.firstcomment?.text && lead.lastComment.firstcomment.text !== '-' && (
//       //                 <div style={{ marginBottom: '16px' }}>
//       //                   <div style={{
//       //                     fontWeight: '600',
//       //                     color: mode === 'dark' ? '#90caf9' : '#102dff',
//       //                     fontSize: '14px',
//       //                     marginBottom: '8px',
//       //                     display: 'flex',
//       //                     alignItems: 'center',
//       //                     gap: '6px'
//       //                   }}>
//       //                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                       <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//       //                     </svg>
//       //                     Comment
//       //                   </div>
//       //                   <div style={{
//       //                     padding: '12px 16px',
//       //                     borderRadius: '8px',
//       //                     fontSize: '14px',
//       //                     lineHeight: '1.5',
//       //                     border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                     background: 'transparent'
//       //                   }}>
//       //                     {lead.lastComment.firstcomment.text}
//       //                   </div>
//       //                 </div>
//       //               )}

//       //               {/* Second Comment (Action Plan) */}
//       //               {lead.lastComment.secondcomment?.text && lead.lastComment.secondcomment.text !== '-' && (
//       //                 <div style={{ marginBottom: '12px' }}>
//       //                   <div style={{
//       //                     fontWeight: '600',
//       //                     color: mode === 'dark' ? '#4caf50' : '#2e7d32',
//       //                     fontSize: '14px',
//       //                     marginBottom: '8px',
//       //                     display: 'flex',
//       //                     alignItems: 'center',
//       //                     gap: '6px'
//       //                   }}>
//       //                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                       <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
//       //                       <polyline points="14,2 14,8 20,8"></polyline>
//       //                       <line x1="16" y1="13" x2="8" y2="13"></line>
//       //                       <line x1="16" y1="17" x2="8" y2="17"></line>
//       //                       <polyline points="10,9 9,9 8,9"></polyline>
//       //                     </svg>
//       //                     Action Plan
//       //                   </div>
//       //                   <div style={{
//       //                     padding: '12px 16px',
//       //                     borderRadius: '8px',
//       //                     fontSize: '14px',
//       //                     lineHeight: '1.5',
//       //                     border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                     background: 'transparent'
//       //                   }}>
//       //                     {lead.lastComment.secondcomment.text}
//       //                   </div>
//       //                 </div>
//       //               )}

//       //               {/* Last Updated */}
//       //               <div style={{
//       //                 fontSize: '11px',
//       //                 color: mode === 'dark' ? '#999' : '#888',
//       //                 textAlign: 'center',
//       //                 marginTop: '16px',
//       //                 paddingTop: '12px',
//       //                 borderTop: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//       //                 display: 'flex',
//       //                 alignItems: 'center',
//       //                 justifyContent: 'center',
//       //                 gap: '6px'
//       //               }}>
//       //                 <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //                   <circle cx="12" cy="12" r="10"></circle>
//       //                   <polyline points="12,6 12,12 16,14"></polyline>
//       //                 </svg>
//       //                 Last updated: {lead.lastComment.actionUpdatedAt ?
//       //                   new Date(lead.lastComment.actionUpdatedAt).toLocaleDateString('en-US', {
//       //                     year: 'numeric',
//       //                     month: '2-digit',
//       //                     day: '2-digit'
//       //                   })
//       //                   : 'Unknown'
//       //                 }
//       //               </div>

//       //               {/* زر الإغلاق */}
//       //               <div style={{
//       //                 display: 'flex',
//       //                 justifyContent: 'flex-end',
//       //                 marginTop: '16px',
//       //                 paddingTop: '12px',
//       //                 borderTop: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0'
//       //               }}>
//       //                 <Button
//       //                   variant="outlined"
//       //                   size="small"
//       //                   onClick={handleCloseTooltip}
//       //                   sx={{
//       //                     fontSize: '12px',
//       //                     padding: '4px 12px',
//       //                     minWidth: 'auto'
//       //                   }}
//       //                 >
//       //                   Close
//       //                 </Button>
//       //               </div>
//       //             </div>
//       //           )
//       //         ) : null
//       //       }
//       //       arrow
//       //       placement="left-start"
//       //       open={clickedLeadId === lead._id} // ✅ اضف هذا السطر
//       //       disableHoverListener // ✅ اضف هذا السطر
//       //       disableFocusListener // ✅ اضف هذا السطر
//       //       disableTouchListener // ✅ اضف هذا السطر
//       //       onClose={() => setClickedLeadId(null)} // ✅ اضف هذا السطر
//       //       componentsProps={{
//       //         tooltip: {
//       //           sx: {
//       //             backgroundColor: 'transparent',
//       //             padding: 0,
//       //             m: 0,
//       //             boxShadow: 'none',
//       //             border: 'none',
//       //             overflow: 'visible',
//       //             maxWidth: 'none'
//       //           }
//       //         }
//       //       }}
//       //     >
//       //       <IconButton
//       //         size="small"
//       //         onClick={() => handleIconClick(lead._id)} // ✅ تغيير هنا من onMouseEnter إلى onClick
//       //         sx={{
//       //           color: lead.lastComment ?
//       //             (mode === 'dark' ? '#90caf9' : '#102dff') :
//       //             (mode === 'dark' ? '#666' : '#ccc'),
//       //           '&:hover': {
//       //             backgroundColor: mode === 'dark' ? 'rgba(144, 202, 249, 0.1)' : 'rgba(16, 45, 255, 0.1)',
//       //           }
//       //         }}
//       //       >
//       //         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//       //           <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//       //         </svg>
//       //         {lead.lastComment && (
//       //           <Box
//       //             sx={{
//       //               position: 'absolute',
//       //               top: 4,
//       //               right: 4,
//       //               width: 6,
//       //               height: 6,
//       //               borderRadius: '50%',
//       //               backgroundColor: mode === 'dark' ? '#4caf50' : '#2e7d32',
//       //             }}
//       //           />
//       //         )}
//       //       </IconButton>
//       //     </Tooltip>
//       //   </TableCell>
//       // );

//       case 'lastComment':
//         return (
//           <Box
//             sx={{
//               width: '100%',
//               height: '100%',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//             }}
//             onMouseEnter={() => handleCommentHover(lead._id)}
//             onMouseLeave={handleCommentLeave}
//           >
//             <Tooltip
//               title={
//                 hoveredLeadId === lead._id ? (
//                   loadingComments ? (
//                     <Box
//                       sx={{
//                         padding: '16px',
//                         textAlign: 'center',
//                         minWidth: '120px',
//                       }}
//                     >
//                       <CircularProgress
//                         size={20}
//                         sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                       />
//                       <Typography
//                         sx={{ mt: 1, fontSize: '13px', color: mode === 'dark' ? '#ccc' : '#666' }}
//                       >
//                         Loading...
//                       </Typography>
//                     </Box>
//                   ) : !lead.lastComment ? (
//                     <div
//                       style={{
//                         width: '300px',
//                         maxWidth: '90vw',
//                         padding: '30px 20px',
//                         background: mode === 'dark' ? '#1e1e1e' : '#fff',
//                         borderRadius: '12px',
//                         color: mode === 'dark' ? '#fff' : '#333',
//                         fontSize: '14px',
//                         lineHeight: '1.5',
//                         border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                         boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
//                         textAlign: 'center',
//                       }}
//                     >
//                       <svg
//                         width="48"
//                         height="48"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke={mode === 'dark' ? '#666' : '#999'}
//                         style={{ marginBottom: '16px' }}
//                       >
//                         <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//                       </svg>
//                       <Typography
//                         sx={{
//                           fontSize: '16px',
//                           fontWeight: '500',
//                           color: mode === 'dark' ? '#ccc' : '#666',
//                           mb: 1,
//                         }}
//                       >
//                         No Comments Yet
//                       </Typography>
//                       <Typography
//                         sx={{
//                           fontSize: '13px',
//                           color: mode === 'dark' ? '#999' : '#888',
//                         }}
//                       >
//                         No comments have been added to this lead
//                       </Typography>
//                     </div>
//                   ) : (
//                     <div
//                       style={{
//                         width: '450px',
//                         maxWidth: '90vw',
//                         padding: '20px',
//                         background: mode === 'dark' ? '#1e1e1e' : '#fff',
//                         borderRadius: '12px',
//                         color: mode === 'dark' ? '#fff' : '#333',
//                         fontSize: '14px',
//                         lineHeight: '1.5',
//                         border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                         boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
//                       }}
//                     >
//                       {/* Header - Sales Info + Stage */}
//                       <div
//                         style={{
//                           display: 'flex',
//                           justifyContent: 'space-between',
//                           alignItems: 'flex-start',
//                           marginBottom: '16px',
//                           paddingBottom: '12px',
//                           borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                         }}
//                       >
//                         {/* Sales Info - Avatar with first 2 letters */}
//                         <div
//                           style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '12px',
//                           }}
//                         >
//                           <Avatar
//                             sx={{
//                               width: 40,
//                               height: 40,
//                               bgcolor: '#102dff',
//                               fontSize: '14px',
//                               fontWeight: 'bold',
//                             }}
//                           >
//                             {lead.lastComment.sales?.name
//                               ? lead.lastComment.sales.name.substring(0, 2).toUpperCase()
//                               : '?'}
//                           </Avatar>
//                           <div>
//                             <div
//                               style={{ fontWeight: '600', fontSize: '16px', marginBottom: '2px' }}
//                             >
//                               {lead.lastComment.sales?.name || 'Unknown Sales'}
//                             </div>
//                             <div
//                               style={{ fontSize: '13px', color: mode === 'dark' ? '#ccc' : '#666' }}
//                             >
//                               {lead.lastComment.sales?.role || 'Sales'}
//                             </div>
//                           </div>
//                         </div>

//                         {/* Stage on the right - under sales name */}
//                         {(lead.lastComment.stage || lead.stage) && (
//                           <div
//                             style={{
//                               textAlign: 'right',
//                             }}
//                           >
//                             <div
//                               style={{
//                                 fontWeight: '600',
//                                 color: mode === 'dark' ? '#90caf9' : '#102dff',
//                                 fontSize: '14px',
//                               }}
//                             >
//                               Stage:{' '}
//                               {lead.lastComment.stage?.name || lead.stage?.name || 'Undefined'}
//                             </div>
//                             {lead.lastComment.stageDate && (
//                               <div
//                                 style={{
//                                   fontSize: '11px',
//                                   color: mode === 'dark' ? '#999' : '#888',
//                                   marginTop: '2px',
//                                 }}
//                               >
//                                 <span>
//                                   SD : |{' '}
//                                   {new Date(lead.lastComment.stageDate).toLocaleString('en-US', {
//                                     year: 'numeric',
//                                     month: '2-digit',
//                                     day: '2-digit',
//                                     hour: '2-digit',
//                                     minute: '2-digit',
//                                     hour12: true,
//                                   })}
//                                 </span>
//                               </div>
//                             )}
//                           </div>
//                         )}
//                       </div>

//                       {/* Comment Date */}
//                       {lead.lastComment.firstcomment?.date && (
//                         <div
//                           style={{
//                             display: 'flex',
//                             justifyContent: 'center',
//                             alignItems: 'center',
//                             gap: '6px',
//                             fontSize: '12px',
//                             color: mode === 'dark' ? '#ccc' : '#666',
//                             marginBottom: '16px',
//                             padding: '6px 12px',
//                             background:
//                               mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//                             borderRadius: '6px',
//                           }}
//                         >
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                           >
//                             <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
//                             <line x1="16" y1="2" x2="16" y2="6"></line>
//                             <line x1="8" y1="2" x2="8" y2="6"></line>
//                             <line x1="3" y1="10" x2="21" y2="10"></line>
//                           </svg>
//                           {new Date(lead.lastComment.firstcomment.date).toLocaleDateString() +
//                             ' • ' +
//                             new Date(lead.lastComment.firstcomment.date).toLocaleTimeString(
//                               'en-US',
//                               {
//                                 hour: '2-digit',
//                                 minute: '2-digit',
//                                 hour12: true,
//                               },
//                             )}
//                         </div>
//                       )}

//                       {/* First Comment (Comment) */}
//                       {lead.lastComment.firstcomment?.text &&
//                         lead.lastComment.firstcomment.text !== '-' && (
//                           <div style={{ marginBottom: '16px' }}>
//                             <div
//                               style={{
//                                 fontWeight: '600',
//                                 color: mode === 'dark' ? '#90caf9' : '#102dff',
//                                 fontSize: '14px',
//                                 marginBottom: '8px',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '6px',
//                               }}
//                             >
//                               <svg
//                                 width="16"
//                                 height="16"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                               >
//                                 <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//                               </svg>
//                               Comment
//                             </div>
//                             <div
//                               style={{
//                                 padding: '12px 16px',
//                                 borderRadius: '8px',
//                                 fontSize: '14px',
//                                 lineHeight: '1.5',
//                                 border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                                 background: 'transparent',
//                               }}
//                             >
//                               {lead.lastComment.firstcomment.text}
//                             </div>
//                           </div>
//                         )}

//                       {/* Second Comment (Action Plan) */}
//                       {lead.lastComment.secondcomment?.text &&
//                         lead.lastComment.secondcomment.text !== '-' && (
//                           <div style={{ marginBottom: '12px' }}>
//                             <div
//                               style={{
//                                 fontWeight: '600',
//                                 color: mode === 'dark' ? '#4caf50' : '#2e7d32',
//                                 fontSize: '14px',
//                                 marginBottom: '8px',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '6px',
//                               }}
//                             >
//                               <svg
//                                 width="16"
//                                 height="16"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                               >
//                                 <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
//                                 <polyline points="14,2 14,8 20,8"></polyline>
//                                 <line x1="16" y1="13" x2="8" y2="13"></line>
//                                 <line x1="16" y1="17" x2="8" y2="17"></line>
//                                 <polyline points="10,9 9,9 8,9"></polyline>
//                               </svg>
//                               Action Plan
//                             </div>
//                             <div
//                               style={{
//                                 padding: '12px 16px',
//                                 borderRadius: '8px',
//                                 fontSize: '14px',
//                                 lineHeight: '1.5',
//                                 border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                                 background: 'transparent',
//                               }}
//                             >
//                               {lead.lastComment.secondcomment.text}
//                             </div>
//                           </div>
//                         )}

//                       {/* Last Updated */}
//                       <div
//                         style={{
//                           fontSize: '11px',
//                           color: mode === 'dark' ? '#999' : '#888',
//                           textAlign: 'center',
//                           marginTop: '16px',
//                           paddingTop: '12px',
//                           borderTop: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           gap: '6px',
//                         }}
//                       >
//                         <svg
//                           width="12"
//                           height="12"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           stroke="currentColor"
//                         >
//                           <circle cx="12" cy="12" r="10"></circle>
//                           <polyline points="12,6 12,12 16,14"></polyline>
//                         </svg>
//                         Last updated:{' '}
//                         {lead.lastComment.actionUpdatedAt
//                           ? new Date(lead.lastComment.actionUpdatedAt).toLocaleDateString('en-US', {
//                               year: 'numeric',
//                               month: '2-digit',
//                               day: '2-digit',
//                             })
//                           : 'Unknown'}
//                       </div>
//                     </div>
//                   )
//                 ) : null
//               }
//               arrow
//               placement="left-start"
//               componentsProps={{
//                 tooltip: {
//                   sx: {
//                     backgroundColor: 'transparent',
//                     padding: 0,
//                     m: 0,
//                     boxShadow: 'none',
//                     border: 'none',
//                     overflow: 'visible',
//                     maxWidth: 'none',
//                     zIndex: 9999,
//                   },
//                 },
//               }}
//             >
//               <IconButton
//                 size="small"
//                 sx={{
//                   color: lead.lastComment
//                     ? mode === 'dark'
//                       ? '#90caf9'
//                       : '#102dff'
//                     : mode === 'dark'
//                       ? '#666'
//                       : '#ccc',
//                   '&:hover': {
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(144, 202, 249, 0.1)' : 'rgba(16, 45, 255, 0.1)',
//                   },
//                 }}
//               >
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                   <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
//                 </svg>
//                 {lead.lastComment && (
//                   <Box
//                     sx={{
//                       position: 'absolute',
//                       top: 4,
//                       right: 4,
//                       width: 6,
//                       height: 6,
//                       borderRadius: '50%',
//                       backgroundColor: mode === 'dark' ? '#4caf50' : '#2e7d32',
//                     }}
//                   />
//                 )}
//               </IconButton>
//             </Tooltip>
//           </Box>
//         );

//       case 'stage':
//         return (
//           <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
//             {lead.stage?.name && (
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 {lead.stage.name === 'Done Deal' ? (
//                   <span style={{ fontSize: '18px' }}>🎉</span>
//                 ) : lead.stage.name === 'Pending' ? (
//                   <SevereColdIcon sx={{ color: '#9c27b0', fontSize: '18px' }} />
//                 ) : lead.stage.name === 'Fresh' ? (
//                   <CheckIcon sx={{ fontSize: '18px', color: '#4caf50' }} />
//                 ) : lead.stage.name === 'Not Interested' ? (
//                   <Box
//                     sx={{
//                       fontSize: '18px',
//                       color: '#333',
//                       borderRadius: '50%',
//                       width: '20px',
//                       height: '20px',
//                       backgroundColor: '#333',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                     }}
//                   >
//                     -
//                   </Box>
//                 ) : lead.stage.name === 'EOI' ? (
//                   <EditNoteIcon sx={{ color: '#9c27b0', fontSize: '18px' }} />
//                 ) : lead.stage.name === 'Reservation' ? (
//                   <AssignmentTurnedInIcon sx={{ color: '#9c27b0', fontSize: '18px' }} />
//                 ) : lead.stage.name === 'Transfer' ? (
//                   <TransferWithinAStationIcon sx={{ color: 'red', fontSize: '18px' }} />
//                 ) : (
//                   <Box
//                     sx={{
//                       backgroundColor: moment(lead.stagedateupdated).isBefore(moment())
//                         ? '#CC5500'
//                         : 'royalblue',
//                       borderRadius: '50%',
//                       width: '20px',
//                       height: '20px',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       color: '#fff',
//                     }}
//                   ></Box>
//                 )}
//                 <Typography variant="body2" sx={{ color: mode === 'dark' ? '#fff' : '#666' }}>
//                   {lead?.stage?.name}
//                 </Typography>
//               </Box>
//             )}
//             {lead.stagedateupdated && (
//               <Typography variant="caption" sx={{ color: '#666', fontSize: '11px' }}>
//                 {moment(lead.stagedateupdated).format('DD/MM/YYYY h:mm A')}
//               </Typography>
//             )}
//           </Box>
//         );

//       case 'creationDate':
//         return (
//           <Box>
//             <Typography variant="body2">{formatDate(lead.createdAt)}</Typography>
//             <Typography variant="caption" display="block" color="text.secondary">
//               {moment(lead.createdAt).format('HH:mm')}
//             </Typography>
//           </Box>
//         );

//       case 'actions':
//         return <ClientTable2 user={lead} allusers={() => fetchLeads(searchTerm)} />;

//       default:
//         return <Typography variant="body2">{lead[col.key] || 'N/A'}</Typography>;
//     }
//   };

//   // Render sort icon
//   const renderSortIcon = (field) => {
//     if (sortField !== field) return null;
//     return sortDirection === 'asc' ? (
//       <ArrowUpIcon fontSize="small" />
//     ) : (
//       <ArrowDownIcon fontSize="small" />
//     );
//   };

//   if (!userlogin) {
//     return (
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           height: '100vh',
//           bgcolor: mode === 'dark' ? '#121212' : '#fff',
//         }}
//       >
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         minHeight: '100vh',
//         marginTop: isSmallScreen ? '160px' : isMediumScreen ? '30px' : '50px',
//         marginLeft: isSmallScreen ? '10px' : isMediumScreen ? '30px' : '50px',
//         padding: isSmallScreen ? '10px' : '20px',
//         backgroundColor: mode === 'dark' ? '#121212' : '#fff',
//       }}
//       style={{ marginTop: '75px' }}
//     >
//       {/* Header Section */}
//       <Box
//         sx={{
//           mb: 4,
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           flexWrap: 'wrap',
//           gap: 2,
//         }}
//       >
//         <Box>
//           <Typography
//             variant="h4"
//             component="h1"
//             gutterBottom
//             sx={{ fontWeight: 'bold', color: mode === 'dark' ? '#fff' : '#1976d2' }}
//           >
//             My Leads Dashboard
//           </Typography>
//           <Typography
//             variant="body1"
//             sx={{ color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)' }}
//           >
//             Manage and track all leads added by you
//           </Typography>
//         </Box>

//         <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//           {/* Add New Lead Button */}
//           <Button
//             variant="outlined"
//             startIcon={<AddIcon />}
//             component={Link}
//             to="/addclient"
//             sx={{
//               minWidth: 'auto',
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                 borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//               },
//             }}
//           >
//             Add New Lead
//           </Button>

//           {/* Import Leads Button */}
//           <Button
//             variant="outlined"
//             startIcon={<CloudUploadIcon />}
//             onClick={handleOpenimport2}
//             sx={{
//               minWidth: 'auto',
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                 borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//               },
//             }}
//           >
//             Import Leads
//           </Button>

//           {/* Quick Filter Button */}
//           <Button
//             variant="outlined"
//             startIcon={<FilterListIcon />}
//             onClick={handleQuickFilterOpen}
//             sx={{
//               minWidth: 'auto',
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                 borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//               },
//             }}
//           >
//             Quick Filter
//           </Button>

//           {/* Clear Filters Button - يظهر فقط عندما تكون هناك فلاتر نشطة */}
//           {Object.keys(appliedFilters).length > 0 && (
//             <Button
//               variant="outlined"
//               color="error"
//               startIcon={<CloseIcon />}
//               onClick={handleClearFilters}
//               sx={{
//                 minWidth: 'auto',
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(244, 67, 54, 0.1)' : 'rgba(244, 67, 54, 0.04)',
//                 borderColor: mode === 'dark' ? 'rgba(244, 67, 54, 0.3)' : 'rgba(244, 67, 54, 0.3)',
//                 color: mode === 'dark' ? '#fff' : '#f44336',
//                 '&:hover': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(244, 67, 54, 0.2)' : 'rgba(244, 67, 54, 0.1)',
//                   borderColor: mode === 'dark' ? '#fff' : '#f44336',
//                 },
//               }}
//             >
//               Clear Filters
//             </Button>
//           )}

//           {/* Refresh Button */}
//           <Button
//             variant="outlined"
//             startIcon={<RefreshIcon />}
//             onClick={handleRefresh}
//             disabled={loading}
//             sx={{
//               minWidth: 'auto',
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                 borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//               },
//             }}
//           >
//             {loading ? 'Refreshing...' : 'Refresh'}
//           </Button>

//           {/* Table Settings Button */}
//           <Button
//             variant="outlined"
//             startIcon={<SettingsIcon />}
//             onClick={() => setTableSettingsOpen(true)}
//             sx={{
//               minWidth: 'auto',
//               backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.04)',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               color: mode === 'dark' ? '#fff' : '#1976d2',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(25,118,210,0.1)',
//                 borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//               },
//             }}
//           >
//             Table Settings
//           </Button>
//         </Box>
//       </Box>

//       {/* 🔍 عرض حالة البحث الحالي - مثل الـ Admin */}
//       {searchTerm && (
//         <Box
//           sx={{
//             mt: 2,
//             p: 2,
//             backgroundColor:
//               mode === 'dark' ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.05)',
//             borderRadius: 2,
//           }}
//         >
//           <Typography
//             variant="body2"
//             sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}
//           >
//             <SearchIcon fontSize="small" />
//             <strong>Searching:</strong> "{searchTerm}"
//             {pagination && (
//               <Chip
//                 label={`${pagination.totalItems || leadsData.length} results`}
//                 size="small"
//                 color="primary"
//                 variant="outlined"
//               />
//             )}
//             <Button size="small" variant="outlined" onClick={handleClearSearch} sx={{ ml: 'auto' }}>
//               Clear Search
//             </Button>
//           </Typography>
//           <Typography variant="caption" sx={{ display: 'block', mt: 1, fontFamily: 'monospace' }}>
//             Using{' '}
//             {searchTerm.includes('@')
//               ? 'email'
//               : /^[\+]?[0-9\s\-\(\)\.]+$/.test(searchTerm)
//                 ? 'phone'
//                 : 'keyword'}{' '}
//             search
//           </Typography>
//         </Box>
//       )}

//       {/* Active Filters Display */}
//       {Object.keys(appliedFilters).length > 0 &&
//         (appliedFilters.budget ||
//           appliedFilters.stage?.length > 0 ||
//           appliedFilters.sales?.length > 0 ||
//           appliedFilters.chanel?.length > 0 ||
//           appliedFilters.campaign?.length > 0 ||
//           appliedFilters.project?.length > 0 ||
//           appliedFilters.developer?.length > 0 ||
//           (appliedFilters.createdAt &&
//             (appliedFilters.createdAt.from || appliedFilters.createdAt.to))) && (
//           <Box
//             sx={{
//               mb: 2,
//               p: 2,
//               backgroundColor: mode === 'dark' ? 'rgba(25,118,210,0.1)' : 'rgba(25,118,210,0.05)',
//               borderRadius: 2,
//             }}
//           >
//             <Typography
//               variant="subtitle2"
//               gutterBottom
//               sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}
//             >
//               <FilterListIcon fontSize="small" />
//               Active Filters:
//             </Typography>
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//               {appliedFilters.stage && appliedFilters.stage.length > 0 && (
//                 <Chip
//                   label={`Stage: ${appliedFilters.stage.length}`}
//                   size="small"
//                   color="primary"
//                   variant="outlined"
//                 />
//               )}
//               {appliedFilters.sales && appliedFilters.sales.length > 0 && (
//                 <Chip
//                   label={`Sales: ${appliedFilters.sales.length}`}
//                   size="small"
//                   color="primary"
//                   variant="outlined"
//                 />
//               )}
//               {appliedFilters.chanel && appliedFilters.chanel.length > 0 && (
//                 <Chip
//                   label={`Channel: ${appliedFilters.chanel.length}`}
//                   size="small"
//                   color="primary"
//                   variant="outlined"
//                 />
//               )}
//               {appliedFilters.campaign && appliedFilters.campaign.length > 0 && (
//                 <Chip
//                   label={`Campaign: ${appliedFilters.campaign.length}`}
//                   size="small"
//                   color="primary"
//                   variant="outlined"
//                 />
//               )}
//               {appliedFilters.project && appliedFilters.project.length > 0 && (
//                 <Chip
//                   label={`Project: ${appliedFilters.project.length}`}
//                   size="small"
//                   color="primary"
//                   variant="outlined"
//                 />
//               )}
//               {appliedFilters.developer && appliedFilters.developer.length > 0 && (
//                 <Chip
//                   label={`Developer: ${appliedFilters.developer.length}`}
//                   size="small"
//                   color="primary"
//                   variant="outlined"
//                 />
//               )}
//               {appliedFilters.budget && (
//                 <Chip
//                   label={`Budget: $${appliedFilters.budget}`}
//                   size="small"
//                   color="primary"
//                   variant="outlined"
//                 />
//               )}
//               {appliedFilters.createdAt &&
//                 (appliedFilters.createdAt.from || appliedFilters.createdAt.to) && (
//                   <Chip label="Date Range" size="small" color="primary" variant="outlined" />
//                 )}
//             </Box>
//           </Box>
//         )}

//       {/* Leads Table */}
//       <Paper sx={{ width: '100%', overflow: 'hidden', flexGrow: 1 }}>
//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//             <CircularProgress />
//           </Box>
//         ) : leadsData.length === 0 ? (
//           <Box sx={{ textAlign: 'center', p: 3 }}>
//             <Typography variant="h6" color="textSecondary">
//               {searchTerm ? 'No leads found matching your search' : 'No leads found'}
//             </Typography>
//             <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
//               {searchTerm ? 'Try changing your search criteria' : 'Start by adding your first lead'}
//             </Typography>
//             {searchTerm && (
//               <Button variant="text" onClick={handleClearSearch} sx={{ mt: 2 }}>
//                 Clear Search
//               </Button>
//             )}
//           </Box>
//         ) : (
//           <>
//             <TableContainer sx={{ maxHeight: 600 }}>
//               <Table stickyHeader>
//                 <TableHead>
//                   <TableRow>
//                     {getVisibleColumns().map((col) => (
//                       <TableCell
//                         key={col.key}
//                         sx={{
//                           color: tableConfig.whiteHeaders
//                             ? 'white'
//                             : mode === 'dark'
//                               ? 'white'
//                               : 'primary.contrastText',
//                           fontWeight: 'bold',
//                           width: `${col.width}px`,
//                           minWidth: `${col.width}px`,
//                           maxWidth: `${col.width}px`,
//                           whiteSpace: 'nowrap',
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           fontSize: '0.875rem',
//                           bgcolor: mode === 'dark' ? 'primary.dark' : 'primary.main',
//                         }}
//                       >
//                         {col.key === 'selection' ? (
//                           <Checkbox
//                             checked={selectAll}
//                             onChange={handleSelectAll}
//                             sx={{
//                               color: 'white',
//                               '&.Mui-checked': {
//                                 color: 'white',
//                               },
//                             }}
//                           />
//                         ) : (
//                           col.label
//                         )}
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {leadsData.map((lead) => (
//                     <StyledTableRow key={lead._id}>
//                       {getVisibleColumns().map((col) => (
//                         <TableCell
//                           key={col.key}
//                           sx={{
//                             width: `${col.width}px`,
//                             minWidth: `${col.width}px`,
//                             maxWidth: `${col.width}px`,
//                             verticalAlign: 'top',
//                           }}
//                         >
//                           {renderCell(col, lead)}
//                         </TableCell>
//                       ))}
//                     </StyledTableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <TablePagination
//               rowsPerPageOptions={[5, 25, 50, 100, 200, 300]} // ✅ أضفنا 200 و 300
//               component="div"
//               count={pagination.totalItems || 0}
//               rowsPerPage={rowsPerPage}
//               page={page}
//               onPageChange={handleChangePage}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//               labelRowsPerPage="Rows per page:"
//               labelDisplayedRows={({ from, to, count }) =>
//                 `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
//               }
//             />
//           </>
//         )}
//       </Paper>

//       {/* Elegant Selection Snackbar */}
//       {selectedLeads.length > 0 && (
//         <Box
//           sx={{
//             position: 'fixed',
//             bottom: 24,
//             left: '50%',
//             transform: 'translateX(-50%)',
//             zIndex: 1300,
//             backgroundColor: mode === 'dark' ? 'rgba(30, 30, 30, 0.95)' : 'rgba(45, 45, 45, 0.95)',
//             backdropFilter: 'blur(10px)',
//             color: 'white',
//             borderRadius: '16px',
//             padding: '16px 24px',
//             boxShadow: '0 10px 40px rgba(0,0,0,0.4)',
//             display: 'flex',
//             alignItems: 'center',
//             gap: 3,
//             minWidth: '450px',
//             maxWidth: '90vw',
//             border: `1px solid ${mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.2)'}`,
//           }}
//         >
//           {/* Left Side - Selection Info */}
//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: 2,
//               flex: 1,
//             }}
//           >
//             <Box
//               sx={{
//                 position: 'relative',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//               }}
//             >
//               <AssignmentIcon
//                 sx={{
//                   color: '#4caf50',
//                   fontSize: '28px',
//                 }}
//               />
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   top: -8,
//                   right: -8,
//                   backgroundColor: 'rgba(0,0,0,0.4)',
//                   color: 'white',
//                   borderRadius: '50%',
//                   width: '24px',
//                   height: '24px',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontSize: '12px',
//                   fontWeight: 'bold',
//                   boxShadow: '0 2px 8px rgba(16, 45, 255, 0.5)',
//                 }}
//               >
//                 {selectedLeads.length}
//               </Box>
//             </Box>

//             <Box>
//               <Typography variant="subtitle1" fontWeight="700">
//                 {selectedLeads.length} Lead{selectedLeads.length > 1 ? 's' : ''} Selected
//               </Typography>
//               <Typography variant="caption" sx={{ opacity: 0.8 }}>
//                 Ready for assignment
//               </Typography>
//             </Box>
//           </Box>

//           {/* Right Side - Actions */}
//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: 2,
//             }}
//           >
//             {/* Assign Button */}
//             <Tooltip title="Assign Selected Leads">
//               <IconButton
//                 size="medium"
//                 onClick={handleAssignClick}
//                 sx={{
//                   color: '#4caf50',
//                   backgroundColor: 'rgba(76, 175, 80, 0.1)',
//                   border: '1px solid rgba(76, 175, 80, 0.3)',
//                   borderRadius: '10px',
//                   '&:hover': {
//                     backgroundColor: 'rgba(76, 175, 80, 0.2)',
//                     borderColor: '#4caf50',
//                     transform: 'translateY(-2px)',
//                   },
//                   transition: 'all 0.2s ease',
//                   width: '44px',
//                   height: '44px',
//                 }}
//               >
//                 <PersonAddIcon />
//               </IconButton>
//             </Tooltip>

//             {/* Clear Button */}
//             <Button
//               variant="contained"
//               size="medium"
//               onClick={() => setSelectedLeads([])}
//               sx={{
//                 backgroundColor: ' rgba(0,0,0,0.4)',
//                 color: 'white',
//                 fontWeight: '700',
//                 borderRadius: '10px',
//                 padding: '10px 24px',
//                 textTransform: 'none',
//                 fontSize: '14px',
//                 boxShadow: '0 4px 16px rgba(16, 45, 255, 0.4)',
//                 '&:hover': {
//                   backgroundColor: 'rgba(19, 4, 4, 0.4)',
//                   boxShadow: '0 6px 20px rgba(16, 45, 255, 0.6)',
//                   transform: 'translateY(-2px)',
//                 },
//                 transition: 'all 0.2s ease',
//                 minWidth: '120px',
//               }}
//             >
//               CLEAR
//             </Button>
//           </Box>
//         </Box>
//       )}

//       {/* Modals */}
//       {selectedLead && (
//         <ShowClientsActionsAdvanced
//           user={selectedLead}
//           leadid={selectedLead._id}
//           onClose={() => setSelectedLead(null)}
//         />
//       )}

//       {/* Assign Leads Modal */}
//       {showAssignModal && (
//         <AssignLeadsModal
//           show={showAssignModal}
//           onHide={() => setShowAssignModal(false)}
//           selectedLeads={selectedLeads}
//         />
//       )}

//       {/* Import Leads Modal */}
//       <Modal show={openimport2} onHide={handleCloseimport2} centered size="lg">
//         <Modal.Header
//           closeButton
//           style={{
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#f8f9fa',
//             borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//           }}
//         >
//           <Modal.Title
//             style={{
//               color: mode === 'dark' ? '#fff' : '#000',
//               fontWeight: '600',
//             }}
//           >
//             <CloudUploadIcon style={{ marginRight: '10px', verticalAlign: 'middle' }} />
//             Import Leads from Excel
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body
//           style={{
//             backgroundColor: mode === 'dark' ? '#121212' : '#fff',
//             padding: '0',
//           }}
//         >
//           {/* التبويبات */}
//           <div
//             style={{
//               borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//               padding: '0 20px',
//             }}
//           >
//             <div className="nav nav-tabs border-0">
//               <div className="nav-item">
//                 <button
//                   className={`nav-link ${activeTab === 'settings' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('settings')}
//                   style={{
//                     border: 'none',
//                     backgroundColor: 'transparent',
//                     color:
//                       activeTab === 'settings'
//                         ? mode === 'dark'
//                           ? '#90caf9'
//                           : '#1976d2'
//                         : mode === 'dark'
//                           ? '#999'
//                           : '#666',
//                     fontWeight: '500',
//                     padding: '12px 16px',
//                     borderBottom: activeTab === 'settings' ? '2px solid' : 'none',
//                     borderBottomColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                   }}
//                 >
//                   ⚙️ Import Settings
//                 </button>
//               </div>
//               <div className="nav-item">
//                 <button
//                   className={`nav-link ${activeTab === 'template' ? 'active' : ''}`}
//                   onClick={() => setActiveTab('template')}
//                   style={{
//                     border: 'none',
//                     backgroundColor: 'transparent',
//                     color:
//                       activeTab === 'template'
//                         ? mode === 'dark'
//                           ? '#90caf9'
//                           : '#1976d2'
//                         : mode === 'dark'
//                           ? '#999'
//                           : '#666',
//                     fontWeight: '500',
//                     padding: '12px 16px',
//                     borderBottom: activeTab === 'template' ? '2px solid' : 'none',
//                     borderBottomColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                   }}
//                 >
//                   📋 Excel Template
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* محتوى التبويب الأول: Settings */}
//           {activeTab === 'settings' && (
//             <div style={{ padding: '20px' }}>
//               {/* 🔘 Switch للـ Import in Data Center */}
//               <div className="mb-4">
//                 <div
//                   style={{
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//                     padding: '15px',
//                     borderRadius: '8px',
//                     border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                   }}
//                 >
//                   <div className="d-flex justify-content-between align-items-center mb-3">
//                     <div>
//                       <h6
//                         style={{
//                           fontWeight: '600',
//                           color: mode === 'dark' ? '#fff' : '#000',
//                           marginBottom: '5px',
//                         }}
//                       >
//                         Import Destination
//                       </h6>
//                       <p
//                         style={{
//                           color: mode === 'dark' ? '#aaa' : '#666',
//                           fontSize: '14px',
//                           margin: 0,
//                         }}
//                       >
//                         Choose where to import the leads
//                       </p>
//                     </div>
//                     <div className="d-flex align-items-center">
//                       <span
//                         style={{
//                           marginRight: '10px',
//                           fontSize: '14px',
//                           fontWeight: '500',
//                           color:
//                             mode === 'dark'
//                               ? isDataCenterImport
//                                 ? '#4caf50'
//                                 : '#ff9800'
//                               : isDataCenterImport
//                                 ? '#2e7d32'
//                                 : '#f57c00',
//                         }}
//                       >
//                         {isDataCenterImport ? 'Data Center' : 'Original Leads'}
//                       </span>
//                       <Form.Check
//                         type="switch"
//                         id="import-destination-switch"
//                         checked={isDataCenterImport}
//                         onChange={(e) => setIsDataCenterImport(e.target.checked)}
//                         style={{ transform: 'scale(1.3)' }}
//                       />
//                     </div>
//                   </div>

//                   {/* Visual Indicator */}
//                   <div
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'space-between',
//                       padding: '10px 15px',
//                       backgroundColor: mode === 'dark' ? 'rgba(0,0,0,0.2)' : 'rgba(0,0,0,0.05)',
//                       borderRadius: '6px',
//                       marginTop: '10px',
//                     }}
//                   >
//                     <div style={{ display: 'flex', alignItems: 'center' }}>
//                       <div
//                         style={{
//                           width: '12px',
//                           height: '12px',
//                           borderRadius: '50%',
//                           backgroundColor: isDataCenterImport ? '#4caf50' : '#ff9800',
//                           marginRight: '10px',
//                         }}
//                       ></div>
//                       <div>
//                         <strong
//                           style={{
//                             color: mode === 'dark' ? '#fff' : '#000',
//                             fontSize: '14px',
//                           }}
//                         >
//                           {isDataCenterImport
//                             ? 'Importing in Data Center'
//                             : 'Importing in Original Leads'}
//                         </strong>
//                         <div
//                           style={{
//                             color: mode === 'dark' ? '#aaa' : '#666',
//                             fontSize: '13px',
//                           }}
//                         >
//                           {isDataCenterImport
//                             ? '✓ Leads will be marked as "this in data" (transferefromdata: false)'
//                             : '✓ Leads will be marked as "transferred from data" (transferefromdata: true)'}
//                         </div>
//                       </div>
//                     </div>

//                     <div
//                       style={{
//                         backgroundColor: isDataCenterImport
//                           ? mode === 'dark'
//                             ? 'rgba(76, 175, 80, 0.2)'
//                             : 'rgba(76, 175, 80, 0.1)'
//                           : mode === 'dark'
//                             ? 'rgba(255, 152, 0, 0.2)'
//                             : 'rgba(255, 152, 0, 0.1)',
//                         color: isDataCenterImport ? '#4caf50' : '#ff9800',
//                         padding: '4px 10px',
//                         borderRadius: '12px',
//                         fontSize: '12px',
//                         fontWeight: '600',
//                         border: `1px solid ${isDataCenterImport ? '#4caf50' : '#ff9800'}`,
//                       }}
//                     >
//                       {isDataCenterImport ? 'Data Center' : 'Transferred'}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* File Upload Section */}
//               <div className="mb-4">
//                 <h6
//                   style={{
//                     fontWeight: '600',
//                     color: mode === 'dark' ? '#fff' : '#000',
//                     marginBottom: '15px',
//                   }}
//                 >
//                   📁 Upload Excel File
//                 </h6>

//                 <div
//                   style={{
//                     border: '2px dashed',
//                     borderColor: mode === 'dark' ? '#444' : '#ddd',
//                     borderRadius: '8px',
//                     padding: '30px',
//                     textAlign: 'center',
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.02)',
//                     transition: 'all 0.3s',
//                     cursor: 'pointer',
//                     '&:hover': {
//                       borderColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                       backgroundColor:
//                         mode === 'dark' ? 'rgba(144, 202, 249, 0.05)' : 'rgba(25, 118, 210, 0.05)',
//                     },
//                   }}
//                 >
//                   <CloudUploadIcon
//                     style={{
//                       fontSize: '48px',
//                       color: mode === 'dark' ? '#666' : '#999',
//                       marginBottom: '15px',
//                     }}
//                   />

//                   <div style={{ marginBottom: '15px' }}>
//                     <input
//                       type="file"
//                       id="excel-file-input"
//                       accept=".xlsx,.xls"
//                       onChange={handleFileSelect}
//                       style={{ display: 'none' }}
//                     />
//                     <label
//                       htmlFor="excel-file-input"
//                       style={{
//                         backgroundColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                         color: '#fff',
//                         padding: '10px 20px',
//                         borderRadius: '6px',
//                         cursor: 'pointer',
//                         fontWeight: '500',
//                         display: 'inline-block',
//                         transition: 'all 0.3s',
//                         '&:hover': {
//                           backgroundColor: mode === 'dark' ? '#64b5f6' : '#1565c0',
//                         },
//                       }}
//                     >
//                       Browse Files
//                     </label>
//                   </div>

//                   <div
//                     style={{
//                       color: mode === 'dark' ? '#aaa' : '#666',
//                       fontSize: '14px',
//                     }}
//                   >
//                     <div>Supported formats: .xlsx, .xls</div>
//                     <div>Max file size: 10MB</div>
//                   </div>
//                 </div>
//               </div>

//               {/* Selected File Preview */}
//               {fileimport2 && (
//                 <div className="mb-4">
//                   <div
//                     style={{
//                       backgroundColor:
//                         mode === 'dark' ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.05)',
//                       padding: '15px',
//                       borderRadius: '8px',
//                       border:
//                         mode === 'dark'
//                           ? '1px solid rgba(25, 118, 210, 0.3)'
//                           : '1px solid rgba(25, 118, 210, 0.2)',
//                     }}
//                   >
//                     <div className="d-flex justify-content-between align-items-center mb-2">
//                       <div>
//                         <strong style={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}>
//                           📎 Selected File
//                         </strong>
//                         <div style={{ fontSize: '13px', color: mode === 'dark' ? '#aaa' : '#666' }}>
//                           Ready for import to{' '}
//                           <strong>{isDataCenterImport ? 'Data Center' : 'Original Leads'}</strong>
//                         </div>
//                       </div>
//                       <span
//                         style={{
//                           backgroundColor: isDataCenterImport
//                             ? 'rgba(76, 175, 80, 0.2)'
//                             : 'rgba(255, 152, 0, 0.2)',
//                           color: isDataCenterImport ? '#4caf50' : '#ff9800',
//                           padding: '2px 8px',
//                           borderRadius: '12px',
//                           fontSize: '12px',
//                           fontWeight: '600',
//                         }}
//                       >
//                         {isDataCenterImport ? 'Data Center' : 'Transferred'}
//                       </span>
//                     </div>

//                     <div
//                       style={{
//                         backgroundColor:
//                           mode === 'dark' ? 'rgba(0,0,0,0.2)' : 'rgba(255,255,255,0.8)',
//                         padding: '12px',
//                         borderRadius: '6px',
//                       }}
//                     >
//                       <div className="d-flex align-items-center">
//                         <div
//                           style={{
//                             backgroundColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                             color: '#fff',
//                             width: '36px',
//                             height: '36px',
//                             borderRadius: '6px',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             marginRight: '12px',
//                             fontSize: '20px',
//                           }}
//                         >
//                           📄
//                         </div>
//                         <div style={{ flex: 1 }}>
//                           <div
//                             style={{
//                               fontWeight: '500',
//                               color: mode === 'dark' ? '#fff' : '#000',
//                               fontSize: '14px',
//                             }}
//                           >
//                             {fileimport2.name}
//                           </div>
//                           <div
//                             style={{
//                               fontSize: '12px',
//                               color: mode === 'dark' ? '#aaa' : '#666',
//                             }}
//                           >
//                             Size: {(fileimport2.size / 1024).toFixed(2)} KB • Type:{' '}
//                             {fileimport2.type || 'Excel'} • Rows: {previewData.length || 0}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Preview Data */}
//               {/* {previewData.length > 0 && (
//           <div className="mb-4">
//             <h6 style={{ 
//               fontWeight: '600', 
//               color: mode === 'dark' ? '#fff' : '#000',
//               marginBottom: '15px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between'
//             }}>
//               <span>🔍 Data Preview (First 3 rows)</span>
//               <span style={{ 
//                 fontSize: '13px',
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                 backgroundColor: mode === 'dark' ? 'rgba(144, 202, 249, 0.1)' : 'rgba(25, 118, 210, 0.1)',
//                 padding: '2px 8px',
//                 borderRadius: '12px'
//               }}>
//                 {previewData.length} total rows
//               </span>
//             </h6>
            
//             <div style={{ 
//               maxHeight: '200px',
//               overflowY: 'auto',
//               border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//               borderRadius: '6px'
//             }}>
//               <table className="table table-sm mb-0" style={{ 
//                 backgroundColor: mode === 'dark' ? '#1e1e1e' : '#fff'
//               }}>
//                 <thead style={{ 
//                   backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f5f5f5',
//                   position: 'sticky',
//                   top: 0
//                 }}>
//                   <tr>
//                     {Object.keys(previewData[0] || {}).slice(0, 8).map((key) => (
//                       <th key={key} style={{ 
//                         fontSize: '12px',
//                         color: mode === 'dark' ? '#ccc' : '#666',
//                         padding: '8px',
//                         whiteSpace: 'nowrap'
//                       }}>
//                         {key}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {previewData.slice(0, 3).map((row, index) => (
//                     <tr key={index} style={{ 
//                       borderBottom: mode === 'dark' ? '1px solid #333' : '1px solid #f0f0f0'
//                     }}>
//                       {Object.values(row).slice(0, 8).map((value, i) => (
//                         <td key={i} style={{ 
//                           fontSize: '12px',
//                           padding: '8px',
//                           color: mode === 'dark' ? '#e0e0e0' : '#333',
//                           maxWidth: '150px',
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           whiteSpace: 'nowrap'
//                         }}>
//                           {value === null || value === undefined || value === '' ? 
//                             <span style={{ 
//                               color: mode === 'dark' ? '#666' : '#999',
//                               fontStyle: 'italic'
//                             }}>—</span> : 
//                             String(value)
//                           }
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )} */}

//               {previewData.length > 0 && (
//                 <div className="mt-3">
//                   <strong
//                     style={{
//                       color: mode === 'dark' ? '#4caf50' : '#28a745',
//                       fontSize: '15px',
//                     }}
//                   >
//                     ✅ Data Preview (First 2 rows):
//                   </strong>
//                   <div
//                     style={{
//                       maxHeight: 200,
//                       overflowY: 'auto',
//                       border: '1px solid',
//                       borderColor: mode === 'dark' ? '#4caf50' : '#28a745',
//                       padding: 10,
//                       backgroundColor: mode === 'dark' ? 'rgba(76, 175, 80, 0.05)' : '#f8fff9',
//                       borderRadius: '4px',
//                       marginTop: '10px',
//                     }}
//                   >
//                     <table
//                       className="table table-sm table-striped mb-0"
//                       style={{
//                         backgroundColor: mode === 'dark' ? 'rgba(0,0,0,0.2)' : 'transparent',
//                       }}
//                     >
//                       <thead>
//                         <tr
//                           style={{
//                             backgroundColor:
//                               mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'transparent',
//                           }}
//                         >
//                           {Object.keys(previewData[0] || {}).map((key) => (
//                             <th
//                               key={key}
//                               className="text-nowrap"
//                               style={{
//                                 color: mode === 'dark' ? '#fff' : '#000',
//                                 fontSize: '12px',
//                               }}
//                             >
//                               {key}
//                             </th>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {previewData.slice(0, 2).map((row, index) => (
//                           <tr
//                             key={index}
//                             style={{
//                               backgroundColor:
//                                 mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'transparent',
//                             }}
//                           >
//                             {Object.values(row).map((value, i) => (
//                               <td
//                                 key={i}
//                                 className="text-nowrap"
//                                 style={{
//                                   color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : '#000',
//                                   fontSize: '12px',
//                                 }}
//                               >
//                                 {value === null || value === undefined || value === '' ? (
//                                   <span
//                                     style={{
//                                       color:
//                                         mode === 'dark'
//                                           ? 'rgba(255,255,255,0.5)'
//                                           : 'rgba(0,0,0,0.5)',
//                                       fontStyle: 'italic',
//                                     }}
//                                   >
//                                     empty
//                                   </span>
//                                 ) : (
//                                   String(value)
//                                 )}
//                               </td>
//                             ))}
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                   <small
//                     style={{
//                       color: mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
//                       display: 'block',
//                       marginTop: '8px',
//                     }}
//                   >
//                     Showing {Math.min(previewData.length, 2)} of {previewData.length} rows
//                     {previewData.length > 2 && ' - Full data will be imported'}
//                   </small>
//                 </div>
//               )}

//               {/* Upload Button */}
//               <div>
//                 <button
//                   className="w-100 py-2"
//                   onClick={onUploadimportleads2}
//                   disabled={loadingimprt2 || !fileimport2}
//                   style={{
//                     backgroundColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                     color: '#fff',
//                     border: 'none',
//                     borderRadius: '8px',
//                     fontWeight: '600',
//                     fontSize: '16px',
//                     padding: '12px',
//                     cursor: loadingimprt2 || !fileimport2 ? 'not-allowed' : 'pointer',
//                     opacity: loadingimprt2 || !fileimport2 ? 0.6 : 1,
//                     transition: 'all 0.3s',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     gap: '10px',
//                     '&:hover:not(:disabled)': {
//                       backgroundColor: mode === 'dark' ? '#64b5f6' : '#1565c0',
//                       transform: 'translateY(-2px)',
//                       boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
//                     },
//                   }}
//                 >
//                   {loadingimprt2 ? (
//                     <>
//                       <span className="spinner-border spinner-border-sm" role="status"></span>
//                       Importing to {isDataCenterImport ? 'Data Center' : 'Original Leads'}...
//                     </>
//                   ) : (
//                     <>
//                       <CloudUploadIcon />
//                       Import {previewData.length} Leads to{' '}
//                       {isDataCenterImport ? 'Data Center' : 'Original Leads'}
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* محتوى التبويب الثاني: Template */}
//           {activeTab === 'template' && (
//             <div style={{ padding: '20px' }}>
//               {/* ✅ قسم معاينة قالب Excel */}
//               <div
//                 className="mb-4 p-3 border rounded"
//                 style={{
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//                   borderColor: mode === 'dark' ? '#333' : '#dee2e6',
//                 }}
//               >
//                 <div className="d-flex justify-content-between align-items-center mb-2">
//                   <strong
//                     style={{
//                       color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                       fontSize: '16px',
//                     }}
//                   >
//                     📋 Excel Template Preview
//                   </strong>
//                   <Button
//                     variant="outline-primary"
//                     size="sm"
//                     onClick={downloadExcelTemplate}
//                     style={{
//                       borderColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                       color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                       '&:hover': {
//                         backgroundColor:
//                           mode === 'dark' ? 'rgba(144, 202, 249, 0.1)' : 'rgba(25, 118, 210, 0.1)',
//                       },
//                     }}
//                   >
//                     Download Template
//                   </Button>
//                 </div>

//                 <small
//                   className="d-block mb-2"
//                   style={{
//                     color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)',
//                   }}
//                 >
//                   Your Excel file should have these columns (first row as headers):
//                 </small>

//                 <div
//                   style={{
//                     maxHeight: 250,
//                     overflowY: 'auto',
//                     backgroundColor: mode === 'dark' ? 'rgba(0,0,0,0.2)' : '#f8f9fa',
//                     border: '1px solid',
//                     borderColor: mode === 'dark' ? '#444' : '#dee2e6',
//                     borderRadius: '4px',
//                     padding: '10px',
//                     fontFamily: 'monospace',
//                     fontSize: '11px',
//                   }}
//                 >
//                   <table
//                     className="table table-sm table-bordered mb-0"
//                     style={{
//                       backgroundColor: mode === 'dark' ? '#1a1a1a' : 'transparent',
//                       color: mode === 'dark' ? '#fff' : '#000',
//                     }}
//                   >
//                     <thead
//                       style={{
//                         backgroundColor: mode === 'dark' ? '#2d3748' : '#343a40',
//                         color: '#fff',
//                       }}
//                     >
//                       <tr>
//                         <th>name</th>
//                         <th>phone</th>
//                         <th>email</th>
//                         <th>project_name</th>
//                         <th>sales_name</th>
//                         <th>chanel_name</th>
//                         <th>communication_way</th>
//                         <th>stage_name</th>
//                         <th>campaign_name</th>
//                         <th>addby_name</th>
//                         <th>updatedby_name</th>
//                         <th>budget</th>
//                         <th>leedtype</th>
//                         {/* <th>isData</th> */}
//                         <th>stagedateupdated</th>
//                         <th>dayonly</th>
//                         <th>last_stage_date_updated</th>
//                         <th>creation_date</th>
//                         <th>Last_Date_Assigned</th>
//                         {/* الحقول الجديدة */}
//                         <th>question1_text</th>
//                         <th>question1_answer</th>
//                         <th>question2_text</th>
//                         <th>question2_answer</th>
//                         <th>question3_text</th>
//                         <th>question3_answer</th>
//                         <th>question4_text</th>
//                         <th>question4_answer</th>
//                         <th>question5_text</th>
//                         <th>question5_answer</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       <tr
//                         style={{
//                           backgroundColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'transparent',
//                           color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : '#000',
//                         }}
//                       >
//                         <td>Ahmed Hassan</td>
//                         <td>+971501234567</td>
//                         <td>ahmed@email.com</td>
//                         <td>Dubai Hills</td>
//                         <td>Mohamed Ali</td>
//                         <td>008 | A</td>
//                         <td>Call</td>
//                         <td>Follow UP</td>
//                         <td>Summer Campaign</td>
//                         <td>Joun</td>
//                         <td>Joun</td>
//                         <td>1500000</td>
//                         <td>Cold</td>
//                         <td>2024-03-15</td>
//                         <td>2024-03-15</td>
//                         <td>2024-03-15</td>
//                         <td>2024-01-10</td>
//                         <td>2024-03-01</td>
//                         {/* قيم الحقول الجديدة */}
//                         <td>How did you hear about us?</td>
//                         <td>Instagram</td>
//                         <td>Preferred budget range?</td>
//                         <td>2.5M - 3M AED</td>
//                         <td>Interested in payment plan?</td>
//                         <td>Yes, flexible</td>
//                         <td>Preferred location?</td>
//                         <td>Palm Jumeirah</td>
//                         <td>Ready to proceed?</td>
//                         <td>Need to discuss with family</td>
//                       </tr>
//                       <tr
//                         style={{
//                           backgroundColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'transparent',
//                           color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : '#000',
//                         }}
//                       >
//                         <td>Sarah Johnson</td>
//                         <td>+971502345678</td>
//                         <td>sarah@email.com</td>
//                         <td>Palm Jumeirah</td>
//                         <td>Fatima Ahmed</td>
//                         <td>005 |A</td>
//                         <td>Whatsapp</td>
//                         <td>Pending</td>
//                         <td>Luxury Homes</td>
//                         <td>Johan De</td>
//                         <td>Johan De</td>
//                         <td>2800000</td>
//                         <td>Cold</td>
//                         <td>2024-03-10</td>
//                         <td>2024-03-10</td>
//                         <td>2024-03-10</td>
//                         <td>2024-01-25</td>
//                         <td>2024-02-15</td>
//                         {/* قيم الحقول الجديدة */}
//                         <td>How did you hear about us?</td>
//                         <td>Instagram</td>
//                         <td>Preferred budget range?</td>
//                         <td>2.5M - 3M AED</td>
//                         <td>Interested in payment plan?</td>
//                         <td>Yes, flexible</td>
//                         <td>Preferred location?</td>
//                         <td>Palm Jumeirah</td>
//                         <td>Ready to proceed?</td>
//                         <td>Need to discuss with family</td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>

//                 <div className="mt-2">
//                   <small
//                     style={{
//                       color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)',
//                     }}
//                   >
//                     <strong>📌 Important Notes:</strong>
//                     <ul className="mb-0 ps-3" style={{ marginTop: '8px' }}>
//                       <li>
//                         Keep the <strong>exact column names</strong> as shown above (case-sensitive)
//                       </li>
//                       <li>
//                         <strong>project_name, sales_name, chanel_name, stage_name</strong> must
//                         match existing names in the system
//                       </li>
//                       <li>
//                         <strong>Dates format:</strong> YYYY-MM-DD (e.g., 2024-03-15)
//                       </li>
//                       <li>
//                         <strong>Phone numbers:</strong> Include country code (e.g., +971501234567)
//                       </li>
//                       <li>
//                         <strong>isData:</strong> Use "true" for data center leads or "false" for
//                         original leads
//                       </li>
//                       <li>
//                         <strong>leedtype:</strong> Use "Cold" for cold leads
//                       </li>
//                       <li>
//                         <strong>Questions fields:</strong> question1_text to question5_text and
//                         question1_answer to question5_answer are optional text fields
//                       </li>
//                     </ul>
//                   </small>
//                 </div>
//               </div>

//               {/* File Upload Section */}
//               <div className="mb-4">
//                 <h6
//                   style={{
//                     fontWeight: '600',
//                     color: mode === 'dark' ? '#fff' : '#000',
//                     marginBottom: '15px',
//                   }}
//                 >
//                   📁 Test Upload with Template
//                 </h6>

//                 <Form.Group controlId="formFile">
//                   <Form.Label
//                     style={{
//                       textDecoration: 'underline',
//                       cursor: 'pointer',
//                       color: mode === 'dark' ? '#90caf9' : '#007bff',
//                       marginBottom: '10px',
//                       display: 'block',
//                     }}
//                   >
//                     Choose Excel File From Your PC
//                   </Form.Label>
//                   <Form.Control
//                     type="file"
//                     accept=".xlsx,.xls"
//                     onChange={handleFileSelect}
//                     style={{
//                       backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#fff',
//                       color: mode === 'dark' ? '#fff' : '#000',
//                       borderColor: mode === 'dark' ? '#444' : '#ced4da',
//                     }}
//                   />
//                   <Form.Text
//                     style={{
//                       color: mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
//                     }}
//                   >
//                     Supported formats: .xlsx, .xls (Max size: 10MB)
//                   </Form.Text>
//                 </Form.Group>
//               </div>

//               {fileimport2 && (
//                 <div
//                   className="alert alert-info d-flex align-items-center"
//                   style={{
//                     backgroundColor: mode === 'dark' ? 'rgba(13, 110, 253, 0.1)' : '#d1ecf1',
//                     borderColor: mode === 'dark' ? 'rgba(13, 110, 253, 0.3)' : '#bee5eb',
//                     color: mode === 'dark' ? '#90caf9' : '#0c5460',
//                   }}
//                 >
//                   <div className="me-2">📎</div>
//                   <div>
//                     <strong>Selected File:</strong> {fileimport2.name}
//                     <small
//                       className="d-block"
//                       style={{
//                         color:
//                           mode === 'dark' ? 'rgba(144, 202, 249, 0.8)' : 'rgba(12, 84, 96, 0.8)',
//                       }}
//                     >
//                       Size: {(fileimport2.size / 1024).toFixed(2)} KB | Type: {fileimport2.type} |
//                       Last Modified: {new Date(fileimport2.lastModified).toLocaleDateString()}
//                     </small>
//                   </div>
//                 </div>
//               )}

//               {previewData.length > 0 && (
//                 <div className="mt-3">
//                   <strong
//                     style={{
//                       color: mode === 'dark' ? '#4caf50' : '#28a745',
//                       fontSize: '15px',
//                     }}
//                   >
//                     ✅ Data Preview (First 2 rows):
//                   </strong>
//                   <div
//                     style={{
//                       maxHeight: 200,
//                       overflowY: 'auto',
//                       border: '1px solid',
//                       borderColor: mode === 'dark' ? '#4caf50' : '#28a745',
//                       padding: 10,
//                       backgroundColor: mode === 'dark' ? 'rgba(76, 175, 80, 0.05)' : '#f8fff9',
//                       borderRadius: '4px',
//                       marginTop: '10px',
//                     }}
//                   >
//                     <table
//                       className="table table-sm table-striped mb-0"
//                       style={{
//                         backgroundColor: mode === 'dark' ? 'rgba(0,0,0,0.2)' : 'transparent',
//                       }}
//                     >
//                       <thead>
//                         <tr
//                           style={{
//                             backgroundColor:
//                               mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'transparent',
//                           }}
//                         >
//                           {Object.keys(previewData[0] || {}).map((key) => (
//                             <th
//                               key={key}
//                               className="text-nowrap"
//                               style={{
//                                 color: mode === 'dark' ? '#fff' : '#000',
//                                 fontSize: '12px',
//                               }}
//                             >
//                               {key}
//                             </th>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {previewData.slice(0, 2).map((row, index) => (
//                           <tr
//                             key={index}
//                             style={{
//                               backgroundColor:
//                                 mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'transparent',
//                             }}
//                           >
//                             {Object.values(row).map((value, i) => (
//                               <td
//                                 key={i}
//                                 className="text-nowrap"
//                                 style={{
//                                   color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : '#000',
//                                   fontSize: '12px',
//                                 }}
//                               >
//                                 {value === null || value === undefined || value === '' ? (
//                                   <span
//                                     style={{
//                                       color:
//                                         mode === 'dark'
//                                           ? 'rgba(255,255,255,0.5)'
//                                           : 'rgba(0,0,0,0.5)',
//                                       fontStyle: 'italic',
//                                     }}
//                                   >
//                                     empty
//                                   </span>
//                                 ) : (
//                                   String(value)
//                                 )}
//                               </td>
//                             ))}
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                   <small
//                     style={{
//                       color: mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
//                       display: 'block',
//                       marginTop: '8px',
//                     }}
//                   >
//                     Showing {Math.min(previewData.length, 2)} of {previewData.length} rows
//                     {previewData.length > 2 && ' - Full data will be imported'}
//                   </small>
//                 </div>
//               )}

//               {/* Upload Button in Template Tab */}
//               {/* <div className="mt-4">
//           <Button
//             variant="primary"
//             onClick={onUploadimportleads2}
//             disabled={loadingimprt2 || !fileimport2}
//             className="w-100 py-2"
//             style={{
//               backgroundColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//               borderColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//               fontWeight: '600',
//               '&:hover:not(:disabled)': {
//                 backgroundColor: mode === 'dark' ? '#64b5f6' : '#1565c0'
//               }
//             }}
//           >
//             {loadingimprt2 ? (
//               <>
//                 <Spinner animation="border" size="sm" className="me-2" />
//                 Uploading & Processing...
//               </>
//             ) : '📤 Upload Excel File'}
//           </Button>
//         </div> */}

//               {/* Import Results */}
//               {resultimport2 && (
//                 <Alert
//                   variant="success"
//                   className="mt-3"
//                   style={{
//                     backgroundColor: mode === 'dark' ? 'rgba(76, 175, 80, 0.1)' : '#d4edda',
//                     borderColor: mode === 'dark' ? 'rgba(76, 175, 80, 0.3)' : '#c3e6cb',
//                     color: mode === 'dark' ? '#a5d6a7' : '#155724',
//                   }}
//                 >
//                   <div className="d-flex align-items-center">
//                     <div className="me-2">✅</div>
//                     <div>
//                       <strong>Import Completed Successfully!</strong>
//                       <div className="mt-2">
//                         <div className="mb-1">
//                           <span className="badge bg-success me-2">
//                             Imported: {resultimport2.importedCount || 0}
//                           </span>
//                           <span className="badge bg-warning me-2">
//                             Skipped: {resultimport2.skippedCount || 0}
//                           </span>
//                           <span className="badge bg-danger">
//                             Errors: {resultimport2.errors?.length || 0}
//                           </span>
//                         </div>

//                         {resultimport2.errors && resultimport2.errors.length > 0 && (
//                           <div className="mt-2">
//                             <strong>Error Details:</strong>
//                             <div
//                               className="mt-1 small"
//                               style={{ maxHeight: '100px', overflowY: 'auto' }}
//                             >
//                               {resultimport2.errors.slice(0, 5).map((error, i) => (
//                                 <div
//                                   key={i}
//                                   className="border-start border-3 border-danger ps-2 mb-1"
//                                   style={{
//                                     color: mode === 'dark' ? '#f44336' : '#721c24',
//                                   }}
//                                 >
//                                   <strong>Row {error.row}:</strong> {error.message}
//                                 </div>
//                               ))}
//                               {resultimport2.errors.length > 5 && (
//                                 <div
//                                   style={{
//                                     color:
//                                       mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
//                                   }}
//                                 >
//                                   ... and {resultimport2.errors.length - 5} more errors
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         )}

//                         {resultimport2.message && (
//                           <div
//                             className="mt-2"
//                             style={{
//                               color: mode === 'dark' ? '#a5d6a7' : '#155724',
//                             }}
//                           >
//                             <small>{resultimport2.message}</small>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </Alert>
//               )}

//               {errorimport2 && (
//                 <Alert
//                   variant="danger"
//                   className="mt-3"
//                   style={{
//                     backgroundColor: mode === 'dark' ? 'rgba(244, 67, 54, 0.1)' : '#f8d7da',
//                     borderColor: mode === 'dark' ? 'rgba(244, 67, 54, 0.3)' : '#f5c6cb',
//                     color: mode === 'dark' ? '#f44336' : '#721c24',
//                   }}
//                 >
//                   <div className="d-flex align-items-center">
//                     <div className="me-2">❌</div>
//                     <div>
//                       <strong>Import Failed!</strong>
//                       <div className="mt-1">
//                         {typeof errorimport2 === 'string'
//                           ? errorimport2
//                           : errorimport2.message || JSON.stringify(errorimport2, null, 2)}
//                       </div>
//                     </div>
//                   </div>
//                 </Alert>
//               )}
//             </div>
//           )}
//         </Modal.Body>
//         {/* <Modal.Footer style={{ 
//     backgroundColor: mode === 'dark' ? '#1e1e1e' : '#f8f9fa',
//     borderTop: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0'
//   }}>
//     <Button variant="secondary" onClick={handleCloseimport2} style={{
//       backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : '#6c757d',
//       borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : '#6c757d',
//       color: '#fff'
//     }}>
//       Close
//     </Button>
//   </Modal.Footer> */}
//       </Modal>

//       {/* Quick Filter Offcanvas */}
//       <QuickFilterModalForMarketer
//         open={quickFilterOpen}
//         onClose={handleQuickFilterClose}
//         onApplyFilters={handleApplyFilters}
//       />

//       <LeadDuplicationModal
//         open={duplicationModal.open}
//         onClose={() => setDuplicationModal({ open: false, leadId: null, leadName: '' })}
//         leadId={duplicationModal.leadId}
//         leadName={duplicationModal.leadName}
//       />

//       {/* Lead Details Dialog */}
//       <Dialog
//         open={leadDetailsOpen}
//         onClose={() => setLeadDetailsOpen(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         {selectedLead && (
//           <>
//             <DialogTitle>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                 <Avatar sx={{ bgcolor: 'primary.main' }}>{getInitials(selectedLead.name)}</Avatar>
//                 <Box>
//                   <Typography variant="h6">{selectedLead.name}</Typography>
//                   <Typography variant="body2" color="textSecondary">
//                     Created: {formatDate(selectedLead.createdAt)}
//                   </Typography>
//                 </Box>
//               </Box>
//             </DialogTitle>
//             <DialogContent dividers>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" color="textSecondary" gutterBottom>
//                     Contact Information
//                   </Typography>
//                   <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//                     {selectedLead.phone && (
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <PhoneIcon color="action" />
//                         <Typography>{selectedLead.phone}</Typography>
//                       </Box>
//                     )}
//                     {selectedLead.email && (
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <EmailIcon color="action" />
//                         <Typography>{selectedLead.email}</Typography>
//                       </Box>
//                     )}
//                     {selectedLead.whatsappnumber && (
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <WhatsAppIcon color="action" />
//                         <Typography>{selectedLead.whatsappnumber}</Typography>
//                       </Box>
//                     )}
//                   </Box>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="subtitle2" color="textSecondary" gutterBottom>
//                     Lead Details
//                   </Typography>
//                   <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <BusinessIcon color="action" />
//                       <Typography>Project: {selectedLead.project?.name || 'No Project'}</Typography>
//                     </Box>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <PersonIcon color="action" />
//                       <Typography>Sales: {selectedLead.sales?.name || 'Not Assigned'}</Typography>
//                     </Box>
//                     <Box>
//                       <Chip
//                         label={selectedLead.stage?.name || 'No Stage'}
//                         color={getStageColor(selectedLead.stage?.name)}
//                         sx={{ mr: 1 }}
//                       />
//                       <Chip
//                         label={selectedLead.leadisactive === 'true' ? 'Active' : 'Inactive'}
//                         color={getStatusColor(selectedLead.leadisactive)}
//                         variant="outlined"
//                       />
//                     </Box>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </DialogContent>
//             <DialogActions>
//               <Button onClick={() => setLeadDetailsOpen(false)}>Close</Button>
//               <Button variant="contained" color="primary">
//                 Edit Lead
//               </Button>
//             </DialogActions>
//           </>
//         )}
//       </Dialog>

//       {/* Table Settings Drawer */}
//       <Drawer
//         anchor="right"
//         open={tableSettingsOpen}
//         onClose={() => setTableSettingsOpen(false)}
//         PaperProps={{
//           sx: {
//             width: isSmallScreen ? '100%' : 400,
//             backgroundColor: mode === 'dark' ? '#1a1a1a' : '#ffffff',
//             marginTop: '25px',
//           },
//         }}
//       >
//         <Box sx={{ p: 3 }}>
//           <Typography
//             variant="h6"
//             gutterBottom
//             sx={{
//               color: mode === 'dark' ? '#ffffff' : '#fff',
//               fontWeight: 'bold',
//             }}
//           >
//             🛠️ Table Settings
//           </Typography>

//           {/* Export Section */}
//           <Box sx={{ mb: 3 }}>
//             <Typography
//               variant="subtitle2"
//               sx={{
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.9)',
//                 fontWeight: '600',
//                 mb: 1,
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 1,
//               }}
//             >
//               <SystemUpdateAltIcon fontSize="small" />
//               Export Options
//             </Typography>

//             <Button
//               variant="outlined"
//               fullWidth
//               startIcon={<SystemUpdateAltIcon />}
//               onClick={handleExportLeads}
//               disabled={leadsData.length === 0}
//               sx={{
//                 mb: 1,
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(25,118,210,0.04)',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//                 color: mode === 'dark' ? '#fff' : '#fff',
//                 '&:hover': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.08)',
//                   borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//                 },
//               }}
//             >
//               Export with Last Comments
//             </Button>

//             <Button
//               variant="outlined"
//               fullWidth
//               startIcon={<SystemUpdateAltIcon />}
//               onClick={exportFilteredLeadsWithAllComments}
//               disabled={leadsData.length === 0}
//               sx={{
//                 mb: 1,
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(25,118,210,0.04)',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//                 color: mode === 'dark' ? '#fff' : '#fff',
//                 '&:hover': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.08)',
//                   borderColor: mode === 'dark' ? '#fff' : '#1976d2',
//                 },
//               }}
//             >
//               Export with All Comments
//             </Button>
//           </Box>

//           <Divider sx={{ mb: 3 }} />

//           <Typography
//             variant="body2"
//             sx={{
//               mb: 3,
//               color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.7)',
//               fontSize: '0.875rem',
//             }}
//           >
//             Drag to reorder, toggle visibility, and adjust column widths
//           </Typography>

//           <DragDropContext onDragEnd={handleDragEnd}>
//             <Droppable droppableId="columns">
//               {(provided) => (
//                 <List
//                   {...provided.droppableProps}
//                   ref={provided.innerRef}
//                   sx={{
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//                     borderRadius: 2,
//                     p: 1,
//                   }}
//                 >
//                   {tableConfig.columnOrder.map((columnKey, index) => {
//                     const column = tableConfig.columns.find((col) => col.key === columnKey);
//                     if (!column) return null;

//                     return (
//                       <Draggable key={column.key} draggableId={column.key} index={index}>
//                         {(provided, snapshot) => (
//                           <ListItem
//                             ref={provided.innerRef}
//                             {...provided.draggableProps}
//                             {...provided.dragHandleProps}
//                             sx={{
//                               border: '1px solid',
//                               borderColor:
//                                 mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                               borderRadius: 2,
//                               mb: 1,
//                               backgroundColor: snapshot.isDragging
//                                 ? mode === 'dark'
//                                   ? 'rgba(144, 202, 249, 0.2)'
//                                   : 'rgba(25, 118, 210, 0.1)'
//                                 : mode === 'dark'
//                                   ? 'rgba(255,255,255,0.03)'
//                                   : 'rgba(255,255,255,0.8)',
//                               transition: 'all 0.2s ease',
//                             }}
//                           >
//                             <ListItemIcon sx={{ minWidth: 40 }}>
//                               <Checkbox
//                                 checked={column.visible}
//                                 onChange={() => toggleColumnVisibility(column.key)}
//                                 icon={<VisibilityOffIcon />}
//                                 checkedIcon={<VisibilityIcon />}
//                               />
//                             </ListItemIcon>

//                             <ListItemText
//                               primary={
//                                 <Typography
//                                   sx={{
//                                     color: column.visible
//                                       ? mode === 'dark'
//                                         ? '#ffffff'
//                                         : '#000000'
//                                       : mode === 'dark'
//                                         ? 'rgba(255,255,255,0.4)'
//                                         : 'rgba(0,0,0,0.4)',
//                                     fontWeight: '500',
//                                     fontSize: '0.9rem',
//                                     textDecoration: column.visible ? 'none' : 'line-through',
//                                   }}
//                                 >
//                                   {column.label}
//                                 </Typography>
//                               }
//                               secondary={
//                                 <Typography
//                                   sx={{
//                                     color:
//                                       mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                                     fontSize: '0.75rem',
//                                   }}
//                                 >
//                                   Width: {column.width}px
//                                 </Typography>
//                               }
//                               sx={{ flex: 1 }}
//                             />

//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                               <TextField
//                                 size="small"
//                                 type="number"
//                                 value={column.width}
//                                 onChange={(e) =>
//                                   updateColumnWidth(column.key, parseInt(e.target.value) || 100)
//                                 }
//                                 sx={{ width: 70 }}
//                                 inputProps={{ min: 60, max: 400 }}
//                               />

//                               <DragIndicatorIcon
//                                 sx={{
//                                   cursor: 'grab',
//                                   color:
//                                     mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                                 }}
//                               />
//                             </Box>
//                           </ListItem>
//                         )}
//                       </Draggable>
//                     );
//                   })}
//                   {provided.placeholder}
//                 </List>
//               )}
//             </Droppable>
//           </DragDropContext>

//           <Box sx={{ display: 'flex', gap: 1, mt: 3 }}>
//             <Button
//               variant="outlined"
//               fullWidth
//               onClick={resetToDefault}
//               sx={{
//                 color: mode === 'dark' ? '#ffffff' : '#fff',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//               }}
//             >
//               Reset Defaults
//             </Button>

//             <Button
//               variant="contained"
//               fullWidth
//               onClick={() => setTableSettingsOpen(false)}
//               sx={{
//                 backgroundColor: '#1976d2',
//                 '&:hover': {
//                   backgroundColor: '#1565c0',
//                 },
//               }}
//             >
//               Apply Changes
//             </Button>
//           </Box>
//         </Box>
//       </Drawer>
//     </Box>
//   );
// };










// 20-5-2026
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@mui/material';
import DeleteOutlineOutlinedIcon    from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlineOutlinedIcon   from '@mui/icons-material/ModeEditOutlineOutlined';
import RemoveRedEyeOutlinedIcon      from '@mui/icons-material/RemoveRedEyeOutlined';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, CircularProgress, Pagination,
  Avatar, TextField, MenuItem, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, IconButton, Checkbox, Tooltip,
  Snackbar, Drawer, Alert, Switch,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SevereColdIcon               from '@mui/icons-material/SevereCold';
import EditNoteIcon                 from '@mui/icons-material/EditNote';
import AssignmentTurnedInIcon       from '@mui/icons-material/AssignmentTurnedIn';
import AddIcon                      from '@mui/icons-material/Add';
import CloudUploadIcon              from '@mui/icons-material/CloudUpload';
import FilterListIcon               from '@mui/icons-material/FilterList';
import RefreshIcon                  from '@mui/icons-material/Refresh';
import SettingsIcon                 from '@mui/icons-material/Settings';
import PersonAddIcon                from '@mui/icons-material/PersonAdd';
import TransferWithinAStationIcon   from '@mui/icons-material/TransferWithinAStation';
import CloseIcon                    from '@mui/icons-material/Close';
import SystemUpdateAltIcon          from '@mui/icons-material/SystemUpdateAlt';
import CheckIcon                    from '@mui/icons-material/Check';
import VisibilityIcon               from '@mui/icons-material/Visibility';
import VisibilityOffIcon            from '@mui/icons-material/VisibilityOff';
import moment from 'moment';

import { Get_All_Leads_By_Email_User_Marketer_email_Action2 } from '../Redux/Actions/UsersAction';
import { Notify }                        from '../Utility/Notify';
import { ClientTable2 }                  from '../Component/ClientTable2';
import { AssignLeadsModal }              from './AssignLeadsModal';
import { ShowClientsActionsAdvanced }    from './ShowClientsActionsAdvanced';
import { LeadDuplicationModal }          from './LeadDuplicationModal';
import QuickFilterModalForMarketer       from './QuickFilterModalForMarketer';
import { useSidebarWidth }               from '../Utility/useSidebarWidth';
import XLSX                              from '../utils/excelUtils';
import axios                             from 'axios';
import { db_url }                        from '../Api/BaseUrl';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

// ─── Tokens ───────────────────────────────────────────────────────────────────
const C = {
  bg:          '#F7F8FC',
  white:       '#FFFFFF',
  border:      '#E8EAF0',
  accent:      '#0D47A1',
  accentDark:  '#1330A6',
  accentSoft:  'rgba(26,62,207,0.07)',
  text:        '#1C2340',
  textMuted:   '#7B829A',
  success:     '#12B76A',
  successSoft: 'rgba(18,183,106,0.08)',
  warning:     '#F79009',
  danger:      '#F04438',
  dangerSoft:  'rgba(240,68,56,0.08)',
  shadow:      '0 1px 3px rgba(16,24,40,0.08)',
};

const SIDEBAR_COLLAPSED = 64;

const StyledRow = styled(TableRow)(() => ({
  '&:hover': { backgroundColor: 'rgba(26,62,207,0.03)' },
  '& td': { borderBottom: `1px solid ${C.border}` },
}));

const StatCard = ({ label, value, badge, highlight }) => (
  <Box sx={{
    bgcolor: highlight ? C.accent : C.white,
    border:  `1px solid ${highlight ? C.accent : C.border}`,
    borderRadius: '12px', p: 2.5,
    width: 160, minWidth: 160, height: 120, minHeight: 120,
    boxShadow: highlight ? '0 4px 16px rgba(26,62,207,0.25)' : C.shadow,
    position: 'relative', overflow: 'hidden', flexShrink: 0,
    display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
  }}>
    {badge && <Box sx={{ position: 'absolute', top: 10, right: 10, bgcolor: C.success, color: '#fff', fontSize: '10px', fontWeight: 700, px: '6px', py: '2px', borderRadius: '20px', fontFamily: "'DM Sans', sans-serif" }}>{badge}</Box>}
    <Typography sx={{ fontSize: '11px', fontWeight: 500, color: highlight ? 'rgba(255,255,255,0.75)' : C.textMuted, letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: "'DM Sans', sans-serif" }}>{label}</Typography>
    <Typography sx={{ fontSize: '26px', fontWeight: 700, color: highlight ? '#fff' : C.text, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.2 }}>{value != null ? String(value) : '—'}</Typography>
    {highlight && <Box sx={{ height: '3px', width: '40px', bgcolor: '#F79009', borderRadius: '2px' }} />}
  </Box>
);

const ActionBtn = ({ icon, label, onClick, primary, disabled, component, to }) => (
  <Button onClick={onClick} disabled={disabled} startIcon={icon} size="small" component={component} to={to}
    sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: '13px', borderRadius: '8px', textTransform: 'none', px: '14px', py: '7px',
      ...(primary
        ? { bgcolor: C.accent, color: '#fff', border: 'none', boxShadow: '0 2px 8px rgba(26,62,207,0.25)', '&:hover': { bgcolor: C.accentDark } }
        : { bgcolor: C.white, color: C.text, border: `1px solid ${C.border}`, '&:hover': { bgcolor: C.bg, borderColor: C.accent, color: C.accent } }
      ),
    }}>
    {label}
  </Button>
);

const PhoneCell = ({ user }) => {
  const [show, setShow] = useState(false);
  return (
    <Box onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <Typography sx={{ fontSize: '13px', color: C.text, mb: '4px' }}>
        {show ? user.phone : `${(user.phone || '').substring(0, 6)}···`}
      </Typography>
      <Box sx={{ display: 'flex', gap: '6px' }}>
        <IconButton size="small" onClick={() => window.open(`https://wa.me/${(user.phone || '').replace(/\D/g, '')}`, '_blank')}
          sx={{ width: 26, height: 26, bgcolor: 'rgba(37,211,102,0.1)', color: '#25D366', '&:hover': { bgcolor: 'rgba(37,211,102,0.2)' } }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </IconButton>
        <IconButton size="small" onClick={() => window.open(`tel:${user.phone}`)}
          sx={{ width: 26, height: 26, bgcolor: 'rgba(26,62,207,0.08)', color: C.accent, '&:hover': { bgcolor: 'rgba(26,62,207,0.15)' } }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
          </svg>
        </IconButton>
      </Box>
    </Box>
  );
};

const ActionsMenu = ({ user, allusers }) => {
  const [anchorEl,    setAnchorEl]    = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [showDelete,  setShowDelete]  = useState(false);
  const open = Boolean(anchorEl);
  const closeMenu = () => setAnchorEl(null);

  return (
    <>
      <ClientTable2 user={user} allusers={allusers} showPreview={showPreview} setShowPreview={setShowPreview} showDelete={showDelete} setShowDelete={setShowDelete} />
      <IconButton size="small" onClick={e => { e.stopPropagation(); setAnchorEl(e.currentTarget); }}
        sx={{ width: 30, height: 30, borderRadius: '8px', color: C.textMuted, '&:hover': { bgcolor: C.accentSoft, color: C.accent }, transition: 'all 0.15s' }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="12" cy="19" r="1.5"/></svg>
      </IconButton>
      {open && (
        <Box onClick={e => e.stopPropagation()} sx={{ position: 'fixed', top: anchorEl ? anchorEl.getBoundingClientRect().bottom + 4 : 0, left: anchorEl ? Math.min(anchorEl.getBoundingClientRect().left - 160, window.innerWidth - 200) : 0, zIndex: 9999, bgcolor: C.white, borderRadius: '12px', border: `1px solid ${C.border}`, boxShadow: '0 8px 32px rgba(16,24,40,0.14)', minWidth: 200, py: '6px', overflow: 'hidden' }}>
          <Box onClick={closeMenu} sx={{ position: 'fixed', inset: 0, zIndex: -1 }} />
          <Box sx={{ px: '8px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <Box component="a" href={`#/updateclient/${user._id}`} onClick={closeMenu} sx={{ display: 'flex', alignItems: 'center', gap: '10px', px: '10px', py: '8px', borderRadius: '8px', color: C.text, textDecoration: 'none', fontSize: '13px', fontFamily: "'DM Sans', sans-serif", fontWeight: 500, '&:hover': { bgcolor: C.accentSoft, color: C.accent } }}>
              <ModeEditOutlineOutlinedIcon sx={{ fontSize: '17px', color: 'inherit' }} />Edit Lead
            </Box>
            <Box onClick={() => { closeMenu(); setShowPreview(true); }} sx={{ display: 'flex', alignItems: 'center', gap: '10px', px: '10px', py: '8px', borderRadius: '8px', color: C.text, fontSize: '13px', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", fontWeight: 500, '&:hover': { bgcolor: 'rgba(127,119,221,0.08)', color: '#7F77DD' } }}>
              <RemoveRedEyeOutlinedIcon sx={{ fontSize: '17px', color: 'inherit' }} />Preview Lead
            </Box>
            {!window.location.hash.includes('AllLeadsnotactivated') && (
              <>
                <Box sx={{ height: '1px', bgcolor: C.border, mx: '4px', my: '4px' }} />
                <Box onClick={() => { closeMenu(); setShowDelete(true); }} sx={{ display: 'flex', alignItems: 'center', gap: '10px', px: '10px', py: '8px', borderRadius: '8px', color: C.danger, fontSize: '13px', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", fontWeight: 500, '&:hover': { bgcolor: 'rgba(240,68,56,0.06)' } }}>
                  <DeleteOutlineOutlinedIcon sx={{ fontSize: '17px', color: 'inherit' }} />Delete Lead
                </Box>
              </>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

const CommentCell = ({ lead }) => {
  const [open, setOpen] = useState(false);
  const lc = lead.lastComment;
  const getInits = (name) => !name ? '?' : name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

  const tooltipContent = !lc ? (
    <Box sx={{ p: 3, textAlign: 'center', bgcolor: '#fff', borderRadius: '16px', minWidth: 200, boxShadow: '0 8px 32px rgba(16,24,40,0.12)', border: '1px solid #E8EAF0' }}>
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#7B829A" strokeWidth="1.5"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
      <Typography sx={{ color: '#7B829A', fontSize: '13px', fontFamily: "'DM Sans', sans-serif", mt: 1 }}>No comments yet</Typography>
    </Box>
  ) : (
    <Box sx={{ width: 380, bgcolor: '#fff', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 20px 40px rgba(16,24,40,0.18)', border: '1px solid #E8EAF0' }}>
      <Box sx={{ px: 3, py: 2, display: 'flex', alignItems: 'center', borderBottom: '1px solid #F0F2F8', bgcolor: '#FAFBFD' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ width: 44, height: 44, borderRadius: '50%', bgcolor: '#1A3ECF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(26,62,207,0.25)' }}>
            <Typography sx={{ color: '#fff', fontSize: '15px', fontWeight: 700, fontFamily: "'DM Sans', sans-serif" }}>{getInits(lc.sales?.name)}</Typography>
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '15px', color: '#1C2340', fontFamily: "'DM Sans', sans-serif", lineHeight: 1.3, mb: 0.5 }}>{lc.sales?.name || 'Unknown'}</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
              {lc.stage?.name && <Box sx={{ px: '10px', py: '3px', borderRadius: '30px', bgcolor: '#EEF1FD', display: 'flex', alignItems: 'center', gap: '4px' }}><Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#1A3ECF' }}/><Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#1A3ECF', fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.06em' }}>{lc.stage.name}</Typography></Box>}
              {lc.firstcomment?.date && <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#7B829A" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg><Typography sx={{ fontSize: '11px', color: '#7B829A', fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{moment(lc.firstcomment.date).format('DD/MM/YYYY h:mm A')}</Typography></Box>}
            </Box>
          </Box>
        </Box>
      </Box>
      {lc.firstcomment?.text && lc.firstcomment.text !== '-' && (
        <Box sx={{ p: 2.5, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ bgcolor: '#F8F9FF', borderRadius: '14px', px: 2, py: 1.5, borderLeft: '3px solid #1A3ECF' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1A3ECF" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg><Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#1A3ECF', fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.05em' }}>Comment</Typography></Box>
            <Typography sx={{ fontSize: '13px', color: '#2A3458', fontFamily: "'DM Sans', sans-serif", lineHeight: 1.55 }}>{lc.firstcomment.text}</Typography>
          </Box>
          {lc.secondcomment?.text && lc.secondcomment.text !== '-' && (
            <Box sx={{ bgcolor: '#FFF8F0', borderRadius: '14px', px: 2, py: 1.5, borderLeft: '3px solid #F59E0B' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2"><circle cx="12" cy="12" r="3"/></svg><Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#F59E0B', fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.05em' }}>Next Plan</Typography></Box>
              <Typography sx={{ fontSize: '13px', color: '#2A3458', fontFamily: "'DM Sans', sans-serif", lineHeight: 1.55 }}>{lc.secondcomment.text}</Typography>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );

  return (
    <Tooltip open={open} onOpen={() => setOpen(true)} onClose={() => setOpen(false)} title={tooltipContent} placement="left-start" arrow={false}
      componentsProps={{ tooltip: { sx: { bgcolor: 'transparent', p: 0, m: 0, boxShadow: 'none', border: 'none', maxWidth: 'none', overflow: 'visible' } } }}>
      <Box onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
        <Box sx={{ width: 36, height: 36, borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: lc ? 'rgba(26,62,207,0.08)' : 'rgba(123,130,154,0.08)', color: lc ? '#1A3ECF' : '#7B829A', position: 'relative', transition: 'all 0.2s', '&:hover': { bgcolor: lc ? 'rgba(26,62,207,0.15)' : 'rgba(123,130,154,0.15)', transform: 'scale(1.02)' } }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          {lc && <Box sx={{ position: 'absolute', top: 2, right: 2, width: 8, height: 8, borderRadius: '50%', bgcolor: '#12B76A', border: '1.5px solid #fff' }} />}
        </Box>
      </Box>
    </Tooltip>
  );
};

const DEFAULT_COLS = [
  { key: 'dup',         label: 'Duplicate',    fieldId: 'DUP_STATUS',  w: 110, visible: true },
  { key: 'name',        label: 'Name',         fieldId: 'CLIENT_NAME', w: 200, visible: true },
  { key: 'phone',       label: 'Phone',        fieldId: 'CONTACT_PH',  w: 140, visible: true },
  { key: 'developer',   label: 'Developer',    fieldId: 'DEV_NAME',    w: 130, visible: true },
  { key: 'project',     label: 'Project',      fieldId: 'ASSET_ID',    w: 160, visible: true },
  { key: 'campaign',    label: 'Campaign',     fieldId: 'CAMPAIGN',    w: 150, visible: true },
  { key: 'channel',     label: 'Channel',      fieldId: 'SRC_CHAN',    w: 120, visible: true },
  { key: 'sales',       label: 'Sales',        fieldId: 'SALES_REP',   w: 150, visible: true },
  { key: 'lastComment', label: 'Last Comment', fieldId: 'LAST_CMT',    w: 60,  visible: true },
  { key: 'stage',       label: 'Stage',        fieldId: 'STAGE_ID',    w: 160, visible: true },
  { key: 'createdAt',   label: 'Created',      fieldId: 'CREATE_DT',   w: 140, visible: true },
  { key: 'actions',     label: 'Actions',      fieldId: 'ACT_BTN',     w: 60,  visible: true },
];

const getInitials = (n = '') =>
  (n || '').split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2) || '?';

export const AllLeadsForMarketerPage = () => {
  const isMobile   = useMediaQuery(useTheme().breakpoints.down('md'));
  const dispatch   = useDispatch();
  const location   = useLocation();
  const sidebarW   = useSidebarWidth();

  const [userlogin,      setUserlogin]      = useState(null);
  const [loading,        setLoading]        = useState(true);
  const [currentPage,    setCurrentPage]    = useState(1);
  const [itemsPerPage,   setItemsPerPage]   = useState(25);
  const [searchQuery,    setSearchQuery]    = useState(localStorage.getItem('searchMarketerstorage') || '');
  const [selectedLeads,  setSelectedLeads]  = useState([]);
  const [selectAll,      setSelectAll]      = useState(false);
  const [selectedLead,   setSelectedLead]   = useState(null);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [colConfig,      setColConfig]      = useState(() => {
    try { const s = localStorage.getItem('marketerColConfig'); return s ? JSON.parse(s) : DEFAULT_COLS; } catch { return DEFAULT_COLS; }
  });

  const [showAssign,    setShowAssign]    = useState(false);
  const [quickFilter,   setQuickFilter]   = useState(false);
  const [settingsOpen,  setSettingsOpen]  = useState(false);
  const [importOpen,    setImportOpen]    = useState(false);
  const [activeTab,     setActiveTab]     = useState('settings');
  const [duplication,   setDuplication]   = useState({ open: false, leadId: null, leadName: '' });

  const [fileImport,    setFileImport]    = useState(null);
  const [previewData,   setPreviewData]   = useState([]);
  const [importLoading, setImportLoading] = useState(false);
  const [importResult,  setImportResult]  = useState(null);
  const [importError,   setImportError]   = useState(null);
  const [isDataCenter,  setIsDataCenter]  = useState(true);

  const currentStageRef    = useRef('');
  const pendingRef         = useRef(null);
  const initialLoadDoneRef = useRef(false);

  useEffect(() => { const u = localStorage.getItem('user'); if (u) setUserlogin(JSON.parse(u)); }, []);
  useEffect(() => { localStorage.setItem('marketerColConfig', JSON.stringify(colConfig)); }, [colConfig]);

  const toggleColVisibility = (key) => setColConfig(p => p.map(c => c.key === key ? { ...c, visible: !c.visible } : c));
  const updateColWidth = (key, w) => setColConfig(p => p.map(c => c.key === key ? { ...c, w: Math.max(60, Math.min(400, parseInt(w) || c.w)) } : c));
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(colConfig);
    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);
    setColConfig(items);
  };

  const Leads      = useSelector(s => s.AllRoleData.Get_Leads_For_Marketer);
  const leadsData  = Leads?.data || [];
  const pagination = Leads?.pagination || {};

  const extractIds = (items) => {
    if (!items?.length) return '';
    return items.map(i => (typeof i === 'string' ? i : i.id || i._id || i.value || '')).filter(Boolean).join(',');
  };

  const loadLeads = useCallback(async (page = 1, limit = itemsPerPage, search = '', stage = '', dups = '', filters = {}) => {
    if (!userlogin?.data?.email) return;
    setLoading(true);
    let q = `email=${userlogin.data.email}&leadisactive=true&page=${page}&limit=${limit}&sort=-date`;
    if (search) {
      const c = search.trim();
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c))    q += `&leadEmail=${encodeURIComponent(c)}`;
      else if (/^[\+]?[0-9\s\-\(\)\.]+$/.test(c))  q += `&phone=${encodeURIComponent(c)}`;
      else                                           q += `&leadName=${encodeURIComponent(c)}`;
    }
    if (stage) q += `&stage=${encodeURIComponent(stage)}`;
    if (dups === 'true') q += `&duplicates=true&ignoreduplicate=true`;
    if (filters && Object.keys(filters).length > 0) {
      ['stage','sales','chanel','campaign','project','developer','oldstage'].forEach(k => {
        if (filters[k]?.length) { const ids = extractIds(filters[k]); if (ids) q += `&${k}=${encodeURIComponent(ids)}`; }
      });
      if (filters.createdAt?.from)        q += `&createdFrom=${encodeURIComponent(filters.createdAt.from)}`;
      if (filters.createdAt?.to)          q += `&createdTo=${encodeURIComponent(filters.createdAt.to)}`;
      if (filters.stagedateupdated?.from) q += `&stageDateFrom=${encodeURIComponent(filters.stagedateupdated.from)}`;
      if (filters.stagedateupdated?.to)   q += `&stageDateTo=${encodeURIComponent(filters.stagedateupdated.to)}`;
      if (filters.budget)                 q += `&budget=${encodeURIComponent(filters.budget)}`;
    }
    try { await dispatch(Get_All_Leads_By_Email_User_Marketer_email_Action2(q)); }
    catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [userlogin, itemsPerPage, dispatch]);

  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    const stage = sp.get('stage'), dups = sp.get('duplicates'), key = stage || dups || 'all';
    if (currentStageRef.current !== key || !initialLoadDoneRef.current) {
      if (pendingRef.current) clearTimeout(pendingRef.current);
      setCurrentPage(1); currentStageRef.current = key;
      pendingRef.current = setTimeout(() => { loadLeads(1, itemsPerPage, searchQuery, stage, dups, appliedFilters); initialLoadDoneRef.current = true; }, 300);
    }
    return () => { if (pendingRef.current) clearTimeout(pendingRef.current); };
  }, [location.search, searchQuery, appliedFilters, loadLeads]);

  useEffect(() => {
    const handler = () => {
      const v = localStorage.getItem('searchMarketerstorage') || '';
      setSearchQuery(v); setCurrentPage(1);
      const sp = new URLSearchParams(location.search);
      loadLeads(1, itemsPerPage, v, sp.get('stage'), sp.get('duplicates'));
    };
    window.addEventListener('searchMarketerUpdated', handler);
    return () => window.removeEventListener('searchMarketerUpdated', handler);
  }, [itemsPerPage, location.search, loadLeads]);

  const toggleLead = (id) => { const y = window.scrollY; setSelectedLeads(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]); setTimeout(() => window.scrollTo(0, y), 10); };
  const toggleAll  = () => { const y = window.scrollY; if (selectAll) { setSelectedLeads([]); setSelectAll(false); } else { setSelectedLeads(leadsData.map(l => l._id)); setSelectAll(true); } setTimeout(() => window.scrollTo(0, y), 10); };
  const handleAssign = () => { if (!selectedLeads.length) return; localStorage.setItem('action', 'Assign'); setShowAssign(true); };

  const refresh = () => {
    setCurrentPage(1); setSelectedLeads([]); setSelectAll(false);
    const sp = new URLSearchParams(location.search);
    loadLeads(1, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'));
  };

  const handleFileSelect = (e) => {
    const f = e.target.files[0]; if (!f) return;
    setFileImport(f); setImportResult(null); setImportError(null);
    const reader = new FileReader();
    reader.onload = async (ev) => { const wb = await XLSX.readAsync(ev.target.result); setPreviewData(XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])); };
    reader.readAsBinaryString(f);
  };
  const doImport = async () => {
    if (!fileImport) return;
    const fd = new FormData(); fd.append('file', fileImport); fd.append('importInDataCenter', isDataCenter);
    setImportLoading(true);
    try {
      const res = await axios.post(`${db_url}api/v1/users/import-leads`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setImportResult(res.data);
      Notify('success', `✅ ${res.data.insertedCount || res.data.importedCount || 0} leads imported!`, 'success');
      setTimeout(() => { setImportOpen(false); setFileImport(null); setPreviewData([]); setImportResult(null); }, 2000);
    } catch (err) { setImportError(err.response?.data?.message || err.message); }
    setImportLoading(false);
    loadLeads(1, itemsPerPage, searchQuery);
  };

  const exportExcel = () => {
    const data = leadsData.map(u => ({ Name: u.name || '', Email: u.email || '', Phone: u.phone || '', Project: u.project?.name || '', Channel: u.chanel?.name || '', Sales: u.sales?.name || '', Stage: u.stage?.name || '', 'Last Comment': u.lastComment?.firstcomment?.text || '', Created: u.createdAt ? moment(u.createdAt).format('DD/MM/YYYY') : '' }));
    const ws = XLSX.utils.json_to_sheet(data); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'My Leads');
    XLSX.writeFile(wb, `My_Leads_${moment().format('YYYY-MM-DD')}.xlsx`);
    Notify('success', `Exported ${data.length} leads`, 'success');
  };
  const exportAllComments = async () => {
    try {
      const response = await axios.get(`${db_url}api/v1/Action`);
      const allActions = response.data.data;
      const data = leadsData.map(lead => {
        const acts = allActions.filter(a => a.leed?._id === lead._id);
        const comments = acts.flatMap(a => a.Comments || []).sort((a, b) => new Date(a.stageDate || a.createdAt) - new Date(b.stageDate || b.createdAt));
        const formatted = comments.map((c, i) => `(${i+1}) [${moment(c.stageDate || c.createdAt).format('DD/MM/YYYY')}] Stage: ${c.stage?.name || 'N/A'} | By: ${c.sales?.name || 'N/A'}\nComment: ${c.firstcomment?.text || ''}\nNext: ${c.secondcomment?.text || ''}`).join('\n\n');
        return { Name: lead.name || '', Phone: lead.phone || '', Sales: lead.sales?.name || '', Stage: lead.stage?.name || '', 'All Comments': formatted || 'No Comments' };
      });
      const ws = XLSX.utils.json_to_sheet(data); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'Leads');
      XLSX.writeFile(wb, `My_Leads_AllComments_${moment().format('YYYY-MM-DD')}.xlsx`);
      Notify('success', 'Exported with all comments', 'success');
    } catch { Notify('error', 'Export failed', 'error'); }
  };

  // ─── Render Cell ──────────────────────────────────────────────────────────
  const renderCell = (col, lead) => {
    // حساب منطق التاريخ مرة واحدة لكل lead
    const stageName = lead.stage?.name || '';
    const isPast = lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment());

    switch (col.key) {
      case 'dup':
        return (
          <Box onClick={() => setDuplication({ open: true, leadId: lead._id, leadName: lead.name })}
            sx={{ display: 'inline-flex', alignItems: 'center', gap: '5px', px: '10px', py: '4px', borderRadius: '20px', border: `1px solid ${C.border}`, fontSize: '12px', fontWeight: 500, cursor: 'pointer', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", '&:hover': { borderColor: C.accent, color: C.accent } }}>
            <Box component="span" sx={{ width: 22, height: 22, borderRadius: '50%', bgcolor: C.accentSoft, color: C.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: 700 }}>{lead.totalSubmissions || 0}</Box>
            Reg.
          </Box>
        );
      case 'name':
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }} onClick={() => setSelectedLead(lead)}>
            <Avatar sx={{ width: 34, height: 34, fontSize: '12px', fontWeight: 700, bgcolor: C.accentSoft, color: C.accent, fontFamily: "'DM Sans', sans-serif" }}>{getInitials(lead.name)}</Avatar>
            <Box>
              <Typography sx={{ fontSize: '13.5px', fontWeight: 600, color: C.text, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.3 }}>{lead.name}</Typography>
              <Typography sx={{ fontSize: '12px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead.email}</Typography>
            </Box>
          </Box>
        );
      case 'phone': return <PhoneCell user={lead} />;
      case 'developer': return <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead?.project?.developer?.name || '—'}</Typography>;
      case 'project': return <Typography sx={{ fontSize: '13px', fontWeight: 500, color: C.text, fontFamily: "'DM Sans', sans-serif" }}>{lead.project?.name || '—'}</Typography>;
      case 'campaign': return <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead.campaign?.CampainName || '—'}</Typography>;
      case 'channel': return <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead.chanel?.name || '—'}</Typography>;
case 'sales':
  return (
    <Tooltip
      title={lead.assigntype === true
        ? `Team: ${lead.sales?.name||'N/A'} | Leader: ${lead.sales?.teamleader?.name||'N/A'}`
        : `Team Leader: ${lead.sales?.teamleader?.name||'N/A'}`
      }
      arrow placement="top"
    >
      <Box sx={{ display:'flex', alignItems:'center', gap:'8px', cursor:'default' }}>
        <Avatar sx={{
          width:30, height:30, fontSize:'11px', fontWeight:700, flexShrink:0,
          fontFamily:"'DM Sans',sans-serif",
          bgcolor: lead.assigntype === true ? 'rgba(13,71,161,0.12)' : 'rgba(247,144,9,0.12)',
          color:   lead.assigntype === true ? C.accent : '#B54708',
        }}>
          {lead.assigntype === true ? 'T' : getInitials(lead.sales?.name)}
        </Avatar>
        <Box>
          <Box sx={{ display:'flex', alignItems:'center', gap:'5px' }}>
            {lead.assigntype === true && (
              <Box sx={{
                fontSize:'9px', fontWeight:800, color:'#fff',
                bgcolor: C.accent, borderRadius:'4px',
                px:'4px', py:'1px', lineHeight:1.4,
                fontFamily:"'DM Sans',sans-serif", letterSpacing:'0.04em',
              }}>
                TL
              </Box>
            )}
            <Typography sx={{
              fontSize:'13px',
              fontWeight: lead.assigntype === true ? 700 : 500,
              color: lead.assigntype === true ? C.accent : C.text,
              fontFamily:"'DM Sans',sans-serif", lineHeight:1.3,
            }}>
              {lead.assigntype === true
                ? (lead.sales?.teamleader?.name || lead.sales?.name || '—')
                : (lead.sales?.name || '—')
              }
            </Typography>
          </Box>
          {lead.lastdateassign && (
            <Typography sx={{ fontSize:'11px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>
              {moment(lead.lastdateassign).format('DD/MM/YY HH:mm')}
            </Typography>
          )}
        </Box>
      </Box>
    </Tooltip>
  );        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Avatar sx={{ width: 30, height: 30, fontSize: '11px', fontWeight: 700, bgcolor: 'rgba(247,144,9,0.12)', color: '#B54708', fontFamily: "'DM Sans', sans-serif", flexShrink: 0 }}>{getInitials(lead.sales?.name)}</Avatar>
            <Box>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: C.text, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.3 }}>{lead.sales?.name || '—'}</Typography>
              {lead.lastdateassign && <Typography sx={{ fontSize: '11px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{moment(lead.lastdateassign).format('DD/MM/YY HH:mm')}</Typography>}
            </Box>
          </Box>
        );
      case 'lastComment': return <CommentCell lead={lead} />;

      case 'stage':
        return (
          <>
            {stageName && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: lead.stagedateupdated ? '4px' : 0 }}>
                {/* ── Icon — منطق التاريخ للـ default ── */}
                {stageName === 'Done Deal'       ? <span style={{ fontSize: '18px' }}>🎉</span>
                : stageName === 'Pending'        ? <SevereColdIcon sx={{ color: '#9c27b0', fontSize: '18px', flexShrink: 0 }} />
                : stageName === 'Fresh'          ? <CheckIcon sx={{ fontSize: '18px', color: '#4caf50', flexShrink: 0 }} />
                : stageName === 'Not Interested' ? <Box sx={{ fontSize: '16px', color: '#fff', borderRadius: '50%', width: '20px', height: '20px', bgcolor: '#555', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, flexShrink: 0 }}>—</Box>
                : stageName === 'EOI'            ? <EditNoteIcon sx={{ color: '#9c27b0', fontSize: '18px', flexShrink: 0 }} />
                : stageName === 'Reservation'    ? <AssignmentTurnedInIcon sx={{ color: '#9c27b0', fontSize: '18px', flexShrink: 0 }} />
                : stageName === 'Transfer'       ? <TransferWithinAStationIcon sx={{ color: '#F04438', fontSize: '18px', flexShrink: 0 }} />
                : <Box sx={{
                    width: 18, height: 18, borderRadius: '50%', flexShrink: 0,
                    bgcolor: isPast ? '#CC5500' : C.accent,
                  }}
                />}

                {/* ── Badge — منطق التاريخ ── */}
                <Box sx={{
                  display: 'inline-flex', alignItems: 'center', px: '8px', py: '3px', borderRadius: '20px',
                  bgcolor:
                    stageName === 'Done Deal'        ? C.successSoft
                    : stageName === 'Pending'        ? 'rgba(156,39,176,0.08)'
                    : stageName === 'Transfer'       ? C.dangerSoft
                    : stageName === 'Not Interested' ? 'rgba(85,85,85,0.08)'
                    : stageName === 'Fresh'          ? 'rgba(76,175,80,0.08)'
                    : isPast ? 'rgba(204,85,0,0.1)' : C.accentSoft,
                  color:
                    stageName === 'Done Deal'        ? C.success
                    : stageName === 'Pending'        ? '#9c27b0'
                    : stageName === 'Transfer'       ? '#F04438'
                    : stageName === 'Not Interested' ? '#555'
                    : stageName === 'Fresh'          ? '#4caf50'
                    : isPast ? '#CC5500' : C.accent,
                }}>
                  <Typography sx={{ fontSize: '11.5px', fontWeight: 600, fontFamily: "'DM Sans', sans-serif", whiteSpace: 'nowrap' }}>{stageName}</Typography>
                </Box>
              </Box>
            )}
            {lead.stagedateupdated && (
              <Typography sx={{ fontSize: '10.5px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", mt: '2px', display: 'flex', alignItems: 'center', gap: '3px' }}>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                {moment(lead.stagedateupdated).format('DD/MM/YY HH:mm')}
              </Typography>
            )}
          </>
        );

      case 'createdAt':
        return (
          <>
            <Typography sx={{ fontSize: '13px', color: C.text, fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{lead.createdAt ? moment(lead.createdAt).format('DD/MM/YY') : '—'}</Typography>
            <Typography sx={{ fontSize: '11px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead.createdAt ? moment(lead.createdAt).format('HH:mm') : ''}</Typography>
          </>
        );
      case 'actions':
        return <ActionsMenu user={lead} allusers={() => loadLeads(currentPage, itemsPerPage, searchQuery)} />;
      default: return null;
    }
  };

  return (
    <Box sx={{ ml: isMobile ? `${SIDEBAR_COLLAPSED}px` : `${sidebarW}px`, mt: '64px', minHeight: 'calc(100vh - 64px)', bgcolor: C.bg, transition: 'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)' }}>
      <Box sx={{ p: isMobile ? 2 : 3.5 }}>

        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 3 }}>
          <Box>
            <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 800, fontSize: isMobile ? '28px' : '36px', color: C.text, lineHeight: 1.15, letterSpacing: '-0.02em' }}>
              My Leads<br />Dashboard
            </Typography>
            <Typography sx={{ fontSize: '13.5px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", mt: 1, maxWidth: 340 }}>
              Manage and track all leads assigned to you with real-time updates.
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'stretch' }}>
            <StatCard label="Total Leads" value={pagination?.totalItems} badge="+NEW" />
            <StatCard label="This Page"   value={leadsData.length} />
            <StatCard label="Pages"       value={pagination?.NumberOfPages} />
            <StatCard label="Conv. Rate"  value={pagination?.activePercentage != null ? `${pagination.activePercentage}%` : '—'} highlight />
          </Box>
        </Box>

        {/* Table card */}
        <Box sx={{ bgcolor: C.white, borderRadius: '12px', border: `1px solid ${C.border}`, boxShadow: C.shadow, overflow: 'hidden' }}>

          {/* Toolbar */}
          <Box sx={{ px: 2.5, py: 2, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', borderBottom: `1px solid ${C.border}` }}>
            <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: '16px', color: C.text, flex: 1 }}>My Live Pipeline</Typography>
            <Tooltip title="Filter"><IconButton size="small" sx={{ color: C.textMuted, '&:hover': { color: C.accent } }} onClick={() => setQuickFilter(true)}><FilterListIcon fontSize="small" /></IconButton></Tooltip>
            <Tooltip title="Refresh"><IconButton size="small" sx={{ color: C.textMuted, '&:hover': { color: C.accent } }} onClick={refresh} disabled={loading}><RefreshIcon fontSize="small" /></IconButton></Tooltip>
            <Tooltip title="Table settings"><IconButton size="small" sx={{ color: C.textMuted, '&:hover': { color: C.accent } }} onClick={() => setSettingsOpen(true)}><SettingsIcon fontSize="small" /></IconButton></Tooltip>
            <Box sx={{ width: '1px', height: '20px', bgcolor: C.border }} />
            <ActionBtn icon={<AddIcon />} label="New Lead" primary component={Link} to="/addclient" />
            <ActionBtn icon={<CloudUploadIcon />} label="Import Leads" onClick={() => { setImportOpen(true); setActiveTab('settings'); setFileImport(null); setPreviewData([]); setImportResult(null); setImportError(null); }} />
          </Box>

          {/* Table */}
          <TableContainer sx={{ overflowX: 'auto' }}>
            <Table size="small" sx={{ minWidth: 700 }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: 52, minWidth: 52, py: '10px', px: '12px', borderBottom: `2px solid ${C.border}` }}>
                    <Checkbox size="small" checked={selectAll} onChange={toggleAll} sx={{ color: C.textMuted }} />
                  </TableCell>
                  {colConfig.filter(c => c.visible).map(col => (
                    <TableCell key={col.key} sx={{ width: col.w, minWidth: col.w, py: '10px', px: '12px', fontFamily: "'DM Sans', sans-serif", fontSize: '11.5px', fontWeight: 600, color: C.textMuted, letterSpacing: '0.05em', textTransform: 'uppercase', borderBottom: `2px solid ${C.border}`, whiteSpace: 'nowrap' }}>
                      {col.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow><TableCell colSpan={colConfig.filter(c => c.visible).length + 1} align="center" sx={{ py: 6 }}><CircularProgress size={32} sx={{ color: C.accent }} /></TableCell></TableRow>
                ) : !leadsData.length ? (
                  <TableRow><TableCell colSpan={colConfig.filter(c => c.visible).length + 1} align="center" sx={{ py: 6 }}><Typography sx={{ color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>No leads found</Typography></TableCell></TableRow>
                ) : leadsData.map(lead => (
                  <StyledRow key={lead._id}>
                    <TableCell sx={{ px: '12px', py: '10px' }}>
                      <Checkbox size="small" checked={selectedLeads.includes(lead._id)} onChange={() => toggleLead(lead._id)} sx={{ color: C.textMuted, '&.Mui-checked': { color: C.accent } }} />
                    </TableCell>
                    {colConfig.filter(c => c.visible).map(col => (
                      <TableCell key={col.key} sx={{ px: '12px', py: '10px', verticalAlign: 'top', width: col.w, minWidth: col.w, maxWidth: col.w }}>
                        {renderCell(col, lead)}
                      </TableCell>
                    ))}
                  </StyledRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          {!loading && leadsData.length > 0 && (
            <Box sx={{ px: 2.5, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'center', borderTop: `1px solid ${C.border}`, flexWrap: 'wrap', gap: 1.5, bgcolor: '#ece8e8', position: 'fixed', bottom: 0, borderRadius: '0px 25px 25px 0px', zIndex: 10, boxShadow: '0 -2px 8px rgba(16,24,40,0.06)' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", whiteSpace: 'nowrap' }}>Rows per page:</Typography>
                <TextField select value={itemsPerPage} onChange={e => { setItemsPerPage(e.target.value); setCurrentPage(1); const sp = new URLSearchParams(location.search); loadLeads(1, e.target.value, searchQuery, sp.get('stage'), sp.get('duplicates'), appliedFilters); }} size="small" sx={{ width: 72, '& .MuiOutlinedInput-root': { borderRadius: '8px', fontSize: '13px' } }}>
                  {[25, 50, 100, 250].map(n => <MenuItem key={n} value={n} sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: '13px' }}>{n}</MenuItem>)}
                </TextField>
              </Box>
              <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>
                Showing <Box component="span" sx={{ fontWeight: 700, color: C.text }}>{leadsData.length}</Box> of <Box component="span" sx={{ fontWeight: 700, color: C.text }}>{pagination?.totalItems || leadsData.length}</Box> results
              </Typography>
              {pagination?.NumberOfPages > 1 && (
                <Pagination count={pagination.NumberOfPages} page={currentPage} size="small" showFirstButton showLastButton
                  onChange={(_, v) => { setCurrentPage(v); const sp = new URLSearchParams(location.search); loadLeads(v, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'), appliedFilters); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                  sx={{ '& .MuiPaginationItem-root': { fontFamily: "'DM Sans', sans-serif", fontSize: '13px', borderRadius: '6px', color: C.textMuted }, '& .Mui-selected': { bgcolor: `${C.accent} !important`, color: '#fff', fontWeight: 700 }, '& .MuiPaginationItem-root:hover': { bgcolor: C.accentSoft } }} />
              )}
            </Box>
          )}
        </Box>
      </Box>

      {/* Snackbar */}
      <Snackbar open={selectedLeads.length > 0} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        message={`${selectedLeads.length} lead(s) selected`}
        action={
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Tooltip title="Assign"><IconButton size="small" onClick={handleAssign} sx={{ color: '#a5d6a7' }}><PersonAddIcon fontSize="small" /></IconButton></Tooltip>
            <Button size="small" onClick={() => { setSelectedLeads([]); setSelectAll(false); }} sx={{ color: '#fff', fontSize: '12px' }}>Clear</Button>
          </Box>
        }
      />

      {/* Modals */}
      {/* {selectedLead && <ShowClientsActionsAdvanced user={selectedLead} leadid={selectedLead._id} onClose={() => setSelectedLead(null)} />} */}
           {selectedLead && (
  <ShowClientsActionsAdvanced
    user={selectedLead}
    leadid={selectedLead._id}
    onClose={() => setSelectedLead(null)}
    onLeadUpdated={() => {
      const sp = new URLSearchParams(location.search);
      loadLeads(currentPage, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'), appliedFilters);
    }}
  />
)}
      <LeadDuplicationModal open={duplication.open} onClose={() => setDuplication({ open: false, leadId: null, leadName: '' })} leadId={duplication.leadId} leadName={duplication.leadName} />
      <QuickFilterModalForMarketer open={quickFilter} onClose={() => setQuickFilter(false)} onApplyFilters={f => { setAppliedFilters(f); setCurrentPage(1); const sp = new URLSearchParams(location.search); loadLeads(1, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'), f); }} />
      {showAssign && <AssignLeadsModal show={showAssign} onHide={() => setShowAssign(false)} selectedLeads={selectedLeads} refreshData={refresh} />}

      {/* Import Modal */}
      <Dialog open={importOpen} onClose={() => setImportOpen(false)} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden' } }}>
        <DialogTitle sx={{ bgcolor: C.accentDark, color: '#fff !important', fontFamily: "'DM Sans', sans-serif", fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}><CloudUploadIcon /><Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: '17px', color: '#fff !important' }}>Import Leads from Excel</Typography></Box>
          <IconButton onClick={() => setImportOpen(false)} sx={{ color: '#fff' }}><CloseIcon /></IconButton>
        </DialogTitle>
        <Box sx={{ borderBottom: `1px solid ${C.border}`, px: 3, display: 'flex', gap: 0 }}>
          {[{ id: 'settings', label: '⚙️ Import Settings' }, { id: 'template', label: '📋 Excel Template' }].map(tab => (
            <Box key={tab.id} onClick={() => setActiveTab(tab.id)} sx={{ py: 1.5, px: 2, cursor: 'pointer', fontSize: '13px', fontWeight: 600, fontFamily: "'DM Sans', sans-serif", color: activeTab === tab.id ? C.accent : C.textMuted, borderBottom: activeTab === tab.id ? `2px solid ${C.accent}` : '2px solid transparent', transition: 'all 0.15s', '&:hover': { color: C.accent } }}>
              {tab.label}
            </Box>
          ))}
        </Box>
        <DialogContent sx={{ p: 0 }}>
          {activeTab === 'settings' && (
            <Box sx={{ p: 3 }}>
              <Box sx={{ mb: 3, p: 2.5, border: `1px solid ${C.border}`, borderRadius: '12px', bgcolor: C.bg }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Box>
                    <Typography sx={{ fontWeight: 700, fontSize: '14px', color: C.text, fontFamily: "'DM Sans', sans-serif" }}>Import Destination</Typography>
                    <Typography sx={{ fontSize: '12px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", mt: '2px' }}>Choose where to import the leads</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: isDataCenter ? C.success : C.warning, fontFamily: "'DM Sans', sans-serif" }}>{isDataCenter ? 'Data Center' : 'Original Leads'}</Typography>
                    <Switch checked={isDataCenter} onChange={e => setIsDataCenter(e.target.checked)} />
                  </Box>
                </Box>
              </Box>
              <Box sx={{ mb: 3 }}>
                <Typography sx={{ fontWeight: 700, fontSize: '13px', color: C.text, fontFamily: "'DM Sans', sans-serif", mb: 1.5 }}>📁 Upload Excel File</Typography>
                <Box onClick={() => document.getElementById('marketer-import-input').click()} sx={{ border: `2px dashed ${C.border}`, borderRadius: '12px', p: 4, textAlign: 'center', cursor: 'pointer', transition: 'all 0.2s', '&:hover': { borderColor: C.accent, bgcolor: C.accentSoft } }}>
                  <CloudUploadIcon sx={{ fontSize: 44, color: C.textMuted, mb: 1.5 }} />
                  <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: '14px', color: C.textMuted, mb: 1 }}>Click to upload <strong style={{ color: C.accent }}>.xlsx / .xls</strong></Typography>
                  <input id="marketer-import-input" type="file" accept=".xlsx,.xls" style={{ display: 'none' }} onChange={handleFileSelect} />
                </Box>
              </Box>
              {fileImport && (
                <Box sx={{ mb: 3, p: 2, bgcolor: C.accentSoft, borderRadius: '10px', border: `1px solid rgba(26,62,207,0.2)`, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Box sx={{ width: 36, height: 36, borderRadius: '8px', bgcolor: C.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' }}>📄</Box>
                  <Box>
                    <Typography sx={{ fontWeight: 600, fontSize: '13px', color: C.text, fontFamily: "'DM Sans', sans-serif" }}>{fileImport.name}</Typography>
                    <Typography sx={{ fontSize: '11px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{(fileImport.size / 1024).toFixed(1)} KB · {previewData.length} rows</Typography>
                  </Box>
                </Box>
              )}
              {previewData.length > 0 && (
                <Box sx={{ mb: 3, maxHeight: 160, overflowY: 'auto', overflowX: 'auto', border: `1px solid ${C.border}`, borderRadius: '8px' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', fontFamily: "'DM Sans', sans-serif" }}>
                    <thead><tr style={{ background: C.bg }}>{Object.keys(previewData[0] || {}).map(k => <th key={k} style={{ padding: '6px 10px', textAlign: 'left', color: C.textMuted, whiteSpace: 'nowrap', fontWeight: 600, borderBottom: `1px solid ${C.border}` }}>{k}</th>)}</tr></thead>
                    <tbody>{previewData.slice(0, 2).map((row, i) => (<tr key={i} style={{ background: i % 2 === 0 ? C.white : C.bg }}>{Object.values(row).map((v, j) => <td key={j} style={{ padding: '6px 10px', color: C.text, whiteSpace: 'nowrap', borderBottom: `1px solid ${C.border}` }}>{v == null || v === '' ? <span style={{ color: C.textMuted, fontStyle: 'italic' }}>—</span> : String(v)}</td>)}</tr>))}</tbody>
                  </table>
                </Box>
              )}
              {importResult && <Alert severity="success" sx={{ mb: 2, borderRadius: '10px' }}>✅ Imported {importResult.insertedCount || importResult.importedCount || 0} leads!</Alert>}
              {importError  && <Alert severity="error"   sx={{ mb: 2, borderRadius: '10px' }}>{importError}</Alert>}
            </Box>
          )}
          {activeTab === 'template' && (
            <Box sx={{ p: 3 }}>
              <Typography sx={{ fontWeight: 700, fontSize: '15px', color: C.text, fontFamily: "'DM Sans', sans-serif", mb: 1 }}>📋 Required column headers</Typography>
              <Box sx={{ maxHeight: 250, overflowX: 'auto', overflowY: 'auto', border: `1px solid ${C.border}`, borderRadius: '10px', mb: 3 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px', fontFamily: "'DM Sans', sans-serif" }}>
                  <thead><tr style={{ background: C.accent }}>{['name','phone','email','project_name','sales_name','chanel_name','stage_name','campaign_name','budget','leedtype','stagedateupdated','creation_date'].map(h => <th key={h} style={{ padding: '7px 10px', color: '#fff', whiteSpace: 'nowrap', fontWeight: 700, textAlign: 'left' }}>{h}</th>)}</tr></thead>
                  <tbody><tr style={{ background: C.bg }}>{['Ahmed Hassan','+971501234567','ahmed@email.com','Dubai Hills','Mohamed Ali','008 | A','Follow UP','Summer Campaign','1500000','Cold','2024-03-15','2024-01-10'].map((v, j) => <td key={j} style={{ padding: '6px 10px', color: C.text, whiteSpace: 'nowrap', borderBottom: `1px solid ${C.border}` }}>{v}</td>)}</tr></tbody>
                </table>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: `1px solid ${C.border}`, bgcolor: C.bg, display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={() => setImportOpen(false)} sx={{ fontFamily: "'DM Sans', sans-serif", color: C.textMuted, textTransform: 'none', borderRadius: '8px' }}>Cancel</Button>
          <Button onClick={doImport} disabled={importLoading || !fileImport} startIcon={importLoading ? <CircularProgress size={16} color="inherit" /> : <CloudUploadIcon />}
            sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: '13px', bgcolor: C.accent, color: '#fff', textTransform: 'none', borderRadius: '8px', px: '20px', '&:hover': { bgcolor: C.accentDark }, '&:disabled': { bgcolor: C.border, color: C.textMuted } }}>
            {importLoading ? 'Importing...' : `Import ${previewData.length > 0 ? previewData.length : ''} Leads`}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Settings Drawer */}
      <Drawer anchor="right" open={settingsOpen} onClose={() => setSettingsOpen(false)} PaperProps={{ sx: { width: 380, bgcolor: '#F4F6FB !important', display: 'flex', flexDirection: 'column' } }}>
        <Box sx={{ px: 2.5, py: 2, bgcolor: C.white, borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton onClick={() => setSettingsOpen(false)} size="small" sx={{ color: C.text, mr: 0.5 }}><CloseIcon fontSize="small" /></IconButton>
          <Typography sx={{ fontWeight: 700, fontSize: '17px', fontFamily: "'DM Sans', sans-serif", color: C.text, flex: 1 }}>Table Settings</Typography>
        </Box>
        <Box sx={{ flex: 1, overflowY: 'auto', scrollbarWidth: 'none' }}>
          <Box sx={{ px: 2.5, pt: 2.5, pb: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {[{ label: 'Export with Last Comment', fn: exportExcel }, { label: 'Export with All Comments', fn: exportAllComments }].map(item => (
              <Box key={item.label} onClick={item.fn} sx={{ display: 'flex', alignItems: 'center', gap: 2, px: 2.5, py: 2, bgcolor: C.accent, borderRadius: '14px', cursor: 'pointer', transition: 'all 0.15s', boxShadow: '0 4px 14px rgba(26,62,207,0.25)', '&:hover': { bgcolor: C.accentDark, transform: 'translateY(-1px)' } }}>
                <Box sx={{ width: 44, height: 44, borderRadius: '10px', bgcolor: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><SystemUpdateAltIcon sx={{ color: '#fff', fontSize: '22px' }} /></Box>
                <Typography sx={{ fontWeight: 700, fontSize: '15px', color: '#fff', fontFamily: "'DM Sans', sans-serif" }}>{item.label}</Typography>
              </Box>
            ))}
          </Box>
          <Box sx={{ px: 2.5, pb: 2 }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 700, color: C.accent, letterSpacing: '0.1em', textTransform: 'uppercase', fontFamily: "'DM Sans', sans-serif", mb: 2 }}>Column Order &amp; Visibility</Typography>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="marketer-columns">
                {(provided) => (
                  <Box ref={provided.innerRef} {...provided.droppableProps} sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {colConfig.map((col, index) => (
                      <Draggable key={col.key} draggableId={col.key} index={index}>
                        {(provided, snapshot) => (
                          <Box ref={provided.innerRef} {...provided.draggableProps} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.5, bgcolor: snapshot.isDragging ? '#E8ECFF' : C.white, borderRadius: '14px', border: `1.5px solid ${snapshot.isDragging ? C.accent : C.border}`, boxShadow: snapshot.isDragging ? '0 8px 24px rgba(26,62,207,0.18)' : '0 1px 3px rgba(16,24,40,0.06)', userSelect: 'none' }}>
                            <IconButton size="small" onClick={() => toggleColVisibility(col.key)} sx={{ width: 34, height: 34, borderRadius: '50%', p: 0, flexShrink: 0, color: col.visible ? C.accent : C.textMuted, bgcolor: col.visible ? C.accentSoft : 'rgba(123,130,154,0.08)' }}>
                              {col.visible ? <VisibilityIcon sx={{ fontSize: '17px' }} /> : <VisibilityOffIcon sx={{ fontSize: '17px' }} />}
                            </IconButton>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography sx={{ fontSize: '14px', fontWeight: 600, color: col.visible ? C.text : C.textMuted, fontFamily: "'DM Sans', sans-serif", textDecoration: col.visible ? 'none' : 'line-through' }}>{col.label}</Typography>
                              <Typography sx={{ fontSize: '10.5px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.05em', textTransform: 'uppercase' }}>ID: {col.fieldId}</Typography>
                            </Box>
                            <Box sx={{ width: 48, height: 36, bgcolor: '#F0F2F9', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                              <input type="number" value={col.w} onChange={e => updateColWidth(col.key, e.target.value)} onClick={e => e.stopPropagation()} style={{ width: '100%', height: '100%', border: 'none', outline: 'none', background: 'transparent', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: C.text, fontFamily: "'DM Sans', sans-serif" }} />
                            </Box>
                            <Box {...provided.dragHandleProps} sx={{ display: 'flex', flexDirection: 'column', gap: '3px', cursor: 'grab', px: '2px', flexShrink: 0 }}>
                              {[0,1,2].map(r => <Box key={r} sx={{ display: 'flex', gap: '3px' }}>{[0,1].map(c => <Box key={c} sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: snapshot.isDragging ? C.accent : C.textMuted, opacity: 0.6 }} />)}</Box>)}
                            </Box>
                          </Box>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Box>
                )}
              </Droppable>
            </DragDropContext>
          </Box>
        </Box>
        <Box sx={{ px: 2.5, py: 2, borderTop: `1px solid ${C.border}`, bgcolor: C.white, display: 'flex', gap: 1 }}>
          <Button fullWidth variant="outlined" onClick={() => setColConfig(DEFAULT_COLS)} sx={{ borderColor: C.border, color: C.textMuted, fontFamily: "'DM Sans', sans-serif", textTransform: 'none', borderRadius: '10px', '&:hover': { borderColor: C.accent, color: C.accent } }}>Reset to Default</Button>
          <Button fullWidth variant="contained" onClick={() => setSettingsOpen(false)} sx={{ bgcolor: C.accent, '&:hover': { bgcolor: C.accentDark }, textTransform: 'none', fontFamily: "'DM Sans', sans-serif", borderRadius: '10px', fontWeight: 600 }}>Done</Button>
        </Box>
      </Drawer>
    </Box>
  );
};
